webpackJsonp([4],{

/***/ 1008:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1015:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1065:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1015)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(529),
  /* template */
  __webpack_require__(1323),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1066:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(960)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(530),
  /* template */
  __webpack_require__(1268),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1067:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(531),
  /* template */
  __webpack_require__(1261),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1068:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(903)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(532),
  /* template */
  __webpack_require__(1211),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1069:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(944)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(533),
  /* template */
  __webpack_require__(1252),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1070:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1008)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(534),
  /* template */
  __webpack_require__(1316),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(921)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(535),
  /* template */
  __webpack_require__(1229),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1072:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(891)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(536),
  /* template */
  __webpack_require__(1199),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1073:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(918)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(537),
  /* template */
  __webpack_require__(1226),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-249fac07",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1074:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(896)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(538),
  /* template */
  __webpack_require__(1204),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1075:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(539),
  /* template */
  __webpack_require__(1295),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1077:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(541),
  /* template */
  __webpack_require__(1247),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1078:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(885)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(542),
  /* template */
  __webpack_require__(1193),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1079:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(975)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(543),
  /* template */
  __webpack_require__(1283),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1080:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(544),
  /* template */
  __webpack_require__(1239),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1081:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(952)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(545),
  /* template */
  __webpack_require__(1260),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1082:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(926)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(546),
  /* template */
  __webpack_require__(1234),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1083:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(922)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(547),
  /* template */
  __webpack_require__(1230),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(935)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(548),
  /* template */
  __webpack_require__(1243),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1085:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(946)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(549),
  /* template */
  __webpack_require__(1254),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1086:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(550),
  /* template */
  __webpack_require__(1236),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1087:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(954)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(551),
  /* template */
  __webpack_require__(1262),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1088:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(895)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(552),
  /* template */
  __webpack_require__(1203),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1089:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(985)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(553),
  /* template */
  __webpack_require__(1293),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1090:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(906)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(554),
  /* template */
  __webpack_require__(1214),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1091:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(995)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(555),
  /* template */
  __webpack_require__(1303),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1092:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(949)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(556),
  /* template */
  __webpack_require__(1257),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1093:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(897)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(557),
  /* template */
  __webpack_require__(1205),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1094:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(905)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(558),
  /* template */
  __webpack_require__(1213),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(938)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(559),
  /* template */
  __webpack_require__(1246),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1096:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(973)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(560),
  /* template */
  __webpack_require__(1281),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1097:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(979)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(561),
  /* template */
  __webpack_require__(1287),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1098:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(971)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(562),
  /* template */
  __webpack_require__(1279),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(933)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(563),
  /* template */
  __webpack_require__(1241),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(988)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(564),
  /* template */
  __webpack_require__(1296),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1193:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "new_guest_book"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'guest_book'
      }
    }
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.back))])]), _vm._v(" "), _c('div', {
    staticClass: "gue_box"
  }, [_c('div', {
    staticClass: "gue_box_user"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.showPage.guestName))]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestName),
      expression: "book.guestName"
    }],
    staticClass: "sign_inp",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.book.guestName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestEmail),
      expression: "book.guestEmail"
    }],
    staticClass: "sign_inp",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.book.guestEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestEmail", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "gue_box_ans mb10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.book.guestMessage),
      expression: "book.guestMessage"
    }],
    staticClass: "sign_txt",
    attrs: {
      "name": "",
      "cols": "",
      "rows": "",
      "placeholder": "留言內容"
    },
    domProps: {
      "value": (_vm.book.guestMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.book, "guestMessage", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('table', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.showPage.verificationCode))]), _vm._v(" "), _c('td', {
    staticClass: "vile"
  }, [_c('vue-recaptcha', {
    ref: "recaptcha",
    attrs: {
      "sitekey": "6LervDYUAAAAAGFkOwdryvivr3SOXgxDt9505Dop"
    },
    on: {
      "verify": _vm.onVerify
    }
  })], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_vm._v(_vm._s(_vm.showPage.leaveMessage))])])], 1)])])
},staticRenderFns: []}

/***/ }),

/***/ 1199:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "all_in",
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "header_all"
  }, [_c('div', {
    staticClass: "header_left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/logo.jpg"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "header_right"
  }, [_c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setLocale('CH')
      }
    }
  }, [_vm._v("中文版")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.setLocale('EN')
      }
    }
  }, [_vm._v("ENGLISH")])])]), _vm._v(" "), _c('div', {
    staticClass: "mt15"
  }, [_c('gcse:search')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "nav_all"
  }, [_c('div', {
    staticClass: "disp_cell"
  }, [_c('ul', {
    staticClass: "drop-down-menu"
  }, _vm._l((_vm.menu), function(itemone, index) {
    return _c('li', {
      key: index
    }, [(!itemone.children[0] && _vm.checkTitle(itemone)) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.linkUrl(itemone)
        }
      }
    }, [_vm._v(_vm._s(_vm.showTitle(itemone)))]) : _vm._e(), _vm._v(" "), (itemone.children[0]) ? _c('a', [_vm._v(_vm._s(_vm.showTitle(itemone)))]) : _vm._e(), _vm._v(" "), (itemone.children[0]) ? _c('ul', {
      staticStyle: {
        "width": "139px"
      }
    }, _vm._l((itemone.children), function(itemtwo, index) {
      return _c('li', {
        key: index
      }, [_c('a', {
        staticStyle: {
          "padding": "0"
        },
        on: {
          "click": function($event) {
            _vm.linkUrl(itemtwo)
          }
        }
      }, [_vm._v(_vm._s(_vm.showTitle(itemtwo)))])])
    })) : _vm._e()])
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "disp_con"
  }, [_c('div', {
    staticClass: "cell_nav_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "cell_nav"
  }, [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.menu), function(itemone) {
    return _c('li', [(itemone.children[0]) ? _c('div', {
      staticClass: "title",
      attrs: {
        "var": itemone.id
      },
      on: {
        "click": _vm.subMenu
      }
    }, [_vm._v("\n                " + _vm._s(_vm.showTitle(itemone)) + "\n              ")]) : _c('div', {
      staticClass: "title clicknav",
      on: {
        "click": _vm.subMenu
      }
    }, [_c('a', {
      on: {
        "click": function($event) {
          _vm.linkUrl(itemone)
        }
      }
    }, [_vm._v(_vm._s(_vm.showTitle(itemone)))])]), _vm._v(" "), (itemone.children[0]) ? _c('div', {
      staticClass: "sub clicknav",
      attrs: {
        "var": itemone.id
      }
    }, [_c('ul', _vm._l((itemone.children), function(itemtwo) {
      return _c('li', [_c('a', {
        on: {
          "click": function($event) {
            _vm.linkUrl(itemtwo)
          }
        }
      }, [_vm._v(_vm._s(_vm.showTitle(itemtwo)))])])
    }))]) : _vm._e()])
  }))])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [(_vm.$route.meta.keepAlive) ? _c('div', {
    staticClass: "con_one"
  }, [_c('div', {
    staticClass: "con_one_left"
  }, [(_vm.noticepictures.length > '1') ? _c('div', {
    staticClass: "carousel slide",
    staticStyle: {
      "overflow": "hidden",
      "height": "340px",
      "position": "relative"
    },
    attrs: {
      "id": "carousel-example-generic",
      "data-ride": "carousel"
    }
  }, [_c('div', {
    staticClass: "carousel-inner",
    attrs: {
      "role": "listbox"
    }
  }, [_vm._l((_vm.noticepictures), function(notice, index) {
    return (index == '0') ? _c('div', {
      key: notice.id,
      staticClass: "item active"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": notice.pictures
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption flex-caption",
      staticStyle: {
        "padding": "10px 20px",
        "text-align": "left",
        "left": "0"
      }
    }, [_vm._v("\n                   " + _vm._s(notice.title) + "\n                ")])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.noticepictures), function(notice, index) {
    return (index > '0' && index < '10') ? _c('div', {
      key: notice.id,
      staticClass: "item"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": notice.pictures
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "carousel-caption flex-caption",
      staticStyle: {
        "padding": "10px 20px",
        "text-align": "left",
        "left": "0"
      }
    }, [_vm._v("\n                   " + _vm._s(notice.title) + "\n                ")])])]) : _vm._e()
  })], 2), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]) : (_vm.noticepictures[0]) ? _c('div', {
    staticStyle: {
      "height": "340px",
      "position": "relative",
      "overflow": "hidden"
    }
  }, [_c('a', {
    attrs: {
      "target": _vm.target(_vm.noticepictures[0]),
      "href": _vm.href(_vm.noticepictures[0])
    },
    on: {
      "click": function($event) {
        _vm.pushToNewsSub(_vm.noticepictures[0])
      }
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.noticepictures[0].pictures
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "carousel-caption flex-caption",
    staticStyle: {
      "height": "40px",
      "bottom": "0",
      "padding": "10px 20px",
      "text-align": "left",
      "left": "0"
    }
  }, [_vm._v("\n                   " + _vm._s(_vm.noticepictures[0].title) + "\n                ")])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "con_one_right"
  }, [_c('div', {
    staticClass: "abgne_tab"
  }, [_c('div', {
    staticClass: "outertab"
  }, [_c('ul', {
    staticClass: "tabs",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, _vm._l((_vm.types), function(type, index) {
    return (type.homeDisplay === 1) ? _c('li', {
      key: index,
      class: {
        active: index === 0
      },
      on: {
        "click": function($event) {
          _vm.selectType(type)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(_vm.showType(type)))])]) : _vm._e()
  }))]), _vm._v(" "), _c('HomeNotice', {
    attrs: {
      "type": _vm.type,
      "notices": _vm.notices
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "con_one_left con_tim"
  }, [_c('router-link', {
    staticClass: "hoverimg",
    attrs: {
      "to": {
        name: 'site'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/8.jpg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "imgwrap"
  }, [_vm._v("場地介紹")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "con_one_right"
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "height": "315",
      "src": _vm.video.fileUrl,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'video'
      }
    }
  }, [_c('button', {
    staticClass: "more_btn fright",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("more")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAlive && _vm.course && false) ? _c('div', {
    staticClass: "con_title con_line"
  }, [_c('router-link', {
    staticStyle: {
      "color": "#00907f"
    },
    attrs: {
      "to": {
        name: 'class'
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.course.schoolYear) + _vm._s(_vm.academicYear) + _vm._s(_vm.showCourseName()) + "\n      ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "con_two"
  }, [(_vm.$route.meta.keepAlive && false) ? _c('div', {
    staticClass: "flexslider"
  }, [_c('ul', {
    staticClass: "slides"
  }, _vm._l((_vm.classes), function(classitem, index) {
    return ((index % 4) == 0) ? _c('li', {
      key: index,
      attrs: {
        "data-thumb": "/../static/images/8.jpg"
      }
    }, [_c('div', {
      staticClass: "bzbox"
    }, [_c('table', [_c('tr', [_c('td', [(_vm.classes[index]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 1]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 1].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 1].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 2]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 2].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 2].id)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [(_vm.classes[index + 3]) ? _c('img', {
      attrs: {
        "src": _vm.classes[index + 3].pictureUrl
      },
      on: {
        "click": function($event) {
          _vm.pushToClassItem(_vm.classes[index + 3].id)
        }
      }
    }) : _vm._e()])])])])]) : _vm._e()
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_all mt40"
  }, [_c('div', {
    staticClass: "footer_box"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "footer_right"
  }, [(_vm.locale == 'CH') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.homeInfoCh)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.locale == 'EN') ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.homeInfoEn)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "footer_link"
  }, _vm._l((_vm.links), function(link, index) {
    return (link.isActive == 1 && link.trash != 1) ? _c('a', {
      key: index,
      attrs: {
        "target": "_blank",
        "href": link.linkUrl
      }
    }, [_c('img', {
      attrs: {
        "src": link.pictureUrl
      }
    })]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "footer_copy"
  }, [_vm._v("\n      臺灣大學體育室版權所有 Copyright " + _vm._s(_vm.nowYear) + " Department of Athletics, NTU All Rights Reserved\n    ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell_nav_close"
  }, [_c('button', {
    staticClass: "cell_nav_close_btn",
    attrs: {
      "type": "button"
    }
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/close.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "disp_con"
  }, [_c('a', {
    staticClass: "toggleMenu"
  }, [_c('button', {
    staticClass: "cell_nav_open_btn",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "left carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Previous")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "right carousel-control",
    attrs: {
      "href": "#carousel-example-generic",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Next")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer_left"
  }, [_c('iframe', {
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3615.422627912698!2d121.53430791500597!3d25.01972768397899!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3442a9882cdc64e7%3A0xcfaa4ee05f721105!2z5ZyL56uL6Ie654Gj5aSn5a246auU6IKy5a6k!5e0!3m2!1szh-TW!2stw!4v1515722591657",
      "width": "100%",
      "height": "350",
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })])
}]}

/***/ }),

/***/ 1203:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_basic"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li"
  }, [_c('div', {
    staticClass: "tea_li_l2"
  }, [_c('div', {
    staticClass: "tea_lititle"
  }, [_vm._v(_vm._s(_vm.teacher.nameEn) + " " + _vm._s(_vm.teacher.nameCh))]), _vm._v(" "), _vm._l((_vm.teacher.background), function(background, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_c('span', {
      staticClass: "tea_tg"
    }, [_vm._v(_vm._s(_vm.showDegree(background)))]), _vm._v(" " + _vm._s(_vm.showSchool(background)) + ", " + _vm._s(background.graduation_year) + "\n        ")])
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_tx mt15"
  }, [_vm._v(_vm._s(_vm.showPage.officeLocation) + " : " + _vm._s(_vm.teacher.office))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.tel) + " : " + _vm._s(_vm.teacher.tel))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v("Email : " + _vm._s(_vm.teacher.email))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.consultationTime) + " : " + _vm._s(_vm.teacher.advisory))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx"
  }, [_vm._v(_vm._s(_vm.showPage.personalWebpage) + " : " + _vm._s(_vm.teacher.website))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "15px",
      "border-bottom": "#ddd 1px solid"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_tx mt15"
  }, [_vm._v(_vm._s(_vm.showTitle(_vm.teacher.title)))]), _vm._v(" "), _vm._l((_vm.teacher.subTitle), function(subTitle, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(subTitle))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tea_li_r2"
  }, [(_vm.teacher.profileImage) ? _c('img', {
    attrs: {
      "src": _vm.teacher.profileImage
    }
  }) : _c('img', {
    attrs: {
      "src": "/../static/images/timeline-default-photo.gif"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.researchArea))]), _vm._v(" "), _vm._l((_vm.teacher.researchArea), function(researchArea, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showResearchArea(researchArea)))])
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.researchSummary))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx",
    domProps: {
      "innerHTML": _vm._s(_vm.showResearchSummary())
    }
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1204:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "journal"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.showPage.type))])]), _vm._v(" "), _vm._l((_vm.types), function(typeobj, index) {
    return _c('tr', {
      key: index,
      on: {
        "click": function($event) {
          _vm.pushToJournal(typeobj)
        }
      }
    }, [_c('td', {
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_vm._v(_vm._s(_vm.showName(typeobj)))])])
  })], 2)])]) : _c('router-view', {
    attrs: {
      "type": _vm.nowType
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1205:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_journal"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 2) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n          " + _vm._s(teacherpublication.context) + "\n        ")]) : _c('span', [_c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.author))
      }
    }), _vm._v(", " + _vm._s(_vm.publication(teacherpublication)) + ",\n          "), _c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.title))
      }
    }), _vm._v(", " + _vm._s(_vm.showName(teacherpublication)) + ", " + _vm._s(_vm.showIssueNumber(teacherpublication)) + ", " + _vm._s(teacherpublication.pageS) + " ~ " + _vm._s(teacherpublication.pageE) + ", "), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.memo) + ")")]) : _vm._e()])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 1211:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "class_item"
    }
  }, [(!_vm.$route.meta.keepAliveSub2) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "ca_title"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showName()))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'coach_info',
        params: {
          classname: _vm.showName()
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.coach_info))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'facility',
        params: {
          classname: _vm.showName()
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_inside',
        params: {
          classname: _vm.showName()
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.apply_class))]), _vm._v(" "), _vm._l((_vm.admissions), function(admission, index) {
    return _c('div', {
      key: index,
      staticClass: "cla_box mt20"
    }, [_c('div', {
      staticClass: "cla_l"
    }, [_vm._v(_vm._s(_vm.classTypeName(admission)))]), _vm._v(" "), _c('div', {
      staticClass: "cla_l"
    }, [_vm._v(_vm._s(admission.memberType))]), _vm._v(" "), (admission.type === 2) ? _c('div', {
      staticClass: "cla_l"
    }, [_vm._v(_vm._s(_vm.memberRange(admission)) + _vm._s(_vm.showPage.people))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "cla_l"
    }, [_vm._v(_vm._s(admission.classHour))]), _vm._v(" "), _c('div', {
      staticClass: "cla_r"
    }, [_c('button', {
      staticClass: "ca2_btn",
      attrs: {
        "type": "submit"
      },
      on: {
        "click": function($event) {
          _vm.signUp(admission.id)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.signup))])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox mt30",
    domProps: {
      "innerHTML": _vm._s(_vm.showNote())
    }
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub2) ? _c('router-view', {
    attrs: {
      "classitem": _vm.classitem
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1213:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_prize"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.award))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.showHonor())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.experience))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.showHistory())
    }
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1214:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_custom"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showName(_vm.customs[_vm.custom])))]), _vm._v(" "), _c('div', {
    staticClass: "tea_tx",
    domProps: {
      "innerHTML": _vm._s(_vm.showContext(_vm.customs[_vm.custom]))
    }
  }, [_vm._v("內容")])])])])
},staticRenderFns: []}

/***/ }),

/***/ 1222:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1226:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab_container"
  }, [_c('div', {
    staticClass: "tab_content",
    staticStyle: {
      "height": "306px"
    },
    attrs: {
      "id": "tab1"
    }
  }, [_c('div', {
    staticClass: "tab_incon"
  }, [_vm._l((_vm.topNotice), function(notice, index) {
    return (index < 4) ? _c('div', {
      key: notice.id
    }, [_c('div', {
      staticClass: "fix"
    }), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "border-bottom": "#ccc 1px dotted",
        "padding": "5px 0",
        "margin-right": "6px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v(_vm._s(notice.createdAt.split(' ')[0]))]), _vm._v(" "), _c('div', {
      staticClass: "right",
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "overflow": "hidden"
      }
    }, [_c('span', {
      staticClass: "nhott"
    }, [_vm._v("HOT")]), _vm._v(_vm._s(notice.title))]), _c('img', {
      attrs: {
        "src": "/../static/images/stickyPin.png"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])])]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.normalNotices), function(notice, index) {
    return _c('div', {
      key: notice.id
    }, [_c('div', {
      staticClass: "fix"
    }), _vm._v(" "), _c('div', {
      staticClass: "list"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(notice),
        "href": _vm.href(notice)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(notice)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "border-bottom": "#ccc 1px dotted",
        "padding": "5px 0",
        "margin-right": "6px"
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v(_vm._s(notice.createdAt.split(' ')[0]))]), _vm._v(" "), _c('div', {
      staticClass: "right",
      staticStyle: {
        "height": "20px",
        "line-height": "20px",
        "overflow": "hidden"
      }
    }, [_vm._v(_vm._s(notice.title))]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "fright mt10"
  }, [_c('button', {
    staticClass: "more_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.pushToNews
    }
  }, [_vm._v("more")])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1229:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "guest_book"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'new_guest_book'
      }
    }
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.leaveMessage))])]), _vm._v(" "), _vm._l((_vm.books), function(book, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "gue_box"
    }, [_c('div', {
      staticClass: "gue_box_user"
    }, [_c('div', {
      staticClass: "gue_box_user_title"
    }, [_vm._v(_vm._s(book.guestName)), _c('i', {
      staticClass: "fa fa-envelope-o ml5",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "gue_box_user_date"
    }, [_vm._v(_vm._s(book.createdAt))]), _vm._v(" "), _c('div', {
      staticClass: "gue_box_user_tx",
      domProps: {
        "innerHTML": _vm._s(_vm.changeBreak(book.guestMessage))
      }
    }), _vm._v(" "), (book.replyDisplay) ? _c('div', {
      staticClass: "gue_box_ans"
    }, [_c('div', {
      staticClass: "gue_box_ans_title"
    }, [_c('i', {
      staticClass: "fa fa-comments-o mr5",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v(_vm._s(_vm.showPage.reply))]), _vm._v(" "), _c('div', {
      staticClass: "gue_box_ans_date"
    }, [_vm._v(_vm._s(book.updatedAt))]), _vm._v(" "), _c('div', {
      staticClass: "gue_box_ans_tx",
      domProps: {
        "innerHTML": _vm._s(_vm.changeBreak(book.reply))
      }
    })]) : _vm._e()])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "total": _vm.books.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1), _vm._v(" "), (_vm.spinShow) ? _c('Spin', {
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1230:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "photo_in"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs'), _c('a', {
    staticStyle: {
      "color": "#888"
    }
  }, [_vm._v("> "), _c('span', {
    staticStyle: {
      "padding-left": "4px"
    }
  }, [_vm._v(_vm._s(_vm.photobread))])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_vm._l((_vm.photos), function(photo, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n          " + _vm._s(photo.memo) + "\n          "), _vm._m(0, true)]), _vm._v(" "), _c('a', {
      attrs: {
        "href": photo.fileUrl,
        "data-lightbox": "pages"
      }
    }, [_vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": photo.fileUrl
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "total": _vm.photos.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt10"
  }, [_c('button', {
    staticClass: "photo_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("more")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "photo_box_icon2"
  }, [_c('button', {
    staticClass: "view_ph",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}

/***/ }),

/***/ 1234:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "photo"
    }
  }, [(!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_c('div', {
    staticClass: "psear mb10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "psear_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.albumSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.showPage.search))])]), _vm._v(" "), _vm._l((_vm.albums), function(album, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'photo_in',
          params: {
            albumId: album.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n            " + _vm._s(_vm.showMemo(album)) + "\n            "), _c('div', {
      staticClass: "mt10"
    }, [_c('button', {
      staticClass: "photo_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("more")])])]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": album.coverPictureUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_title"
    }, [_vm._v(_vm._s(_vm.showName(album)))]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_tx"
    }, [_vm._v(_vm._s(_vm.showPage.totalCount) + _vm._s(album.pictureCount) + _vm._s(_vm.showPage.item))])])], 1) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.albums.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "outerphoto": _vm.albums
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1236:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('Button', {
    staticStyle: {
      "margin": "10px 10px 10px 25px"
    },
    nativeOn: {
      "click": function($event) {
        _vm.back($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.back))]), _vm._v(" "), _vm._l((_vm.sites[_vm.siteindex].pictures), function(picture, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticStyle: {
        "margin": "25px",
        "max-width": "100%"
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "src": picture
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticStyle: {
      "border-left": "3px solid #bbb",
      "padding-left": "10px",
      "font-size": "20px",
      "margin-bottom": "20px"
    }
  }, [_vm._v(_vm._s(_vm.showName(_vm.sites[_vm.siteindex])))]), _vm._v(" "), _c('div', {
    staticClass: "site_link",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction(_vm.sites[_vm.siteindex]))
    }
  })])], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1239:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news_sub"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('div', {
    staticClass: "tx18"
  }, [_vm._v(_vm._s(_vm.news.title))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('div', {
    staticClass: "tx18"
  }, [_vm._v(_vm._s(_vm.news.createdAt && _vm.news.createdAt.split(' ')[0]))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s((_vm.news.context))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_r_l"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.backname))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.attachPicture))]), _vm._v(" "), _vm._l((_vm.news.pictures), function(picture, index) {
    return _c('div', {
      key: 'i' + index
    }, [_c('div', {
      staticStyle: {
        "float": "left",
        "margin": "25px"
      }
    }, [_c('img', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "width": "212",
        "src": picture.file_url
      },
      on: {
        "click": function($event) {
          _vm.showPicture(picture.file_url)
        }
      }
    })])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.attachFile))]), _vm._v(" "), _vm._l((_vm.news.files), function(file, index) {
    return _c('div', {
      key: 'f' + index
    }, [_c('a', {
      attrs: {
        "href": file.file_url,
        "download": ""
      }
    }, [_vm._v(_vm._s(file.file_name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "class-name": "pictureModal"
    },
    model: {
      value: (_vm.pictureModal),
      callback: function($$v) {
        _vm.pictureModal = $$v
      },
      expression: "pictureModal"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1241:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team_type"
    }
  }, [(_vm.$route.meta.keepAliveSub2) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_vm._l((_vm.teams), function(teamitem, index) {
    return (teamitem.type == _vm.teamtypeId) ? _c('div', {
      key: index,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.selectTeam(teamitem)
        }
      }
    }, [_c('div', {
      staticClass: "box2"
    }, [_c('div', {
      staticClass: "class_box"
    }, [_c('div', {
      staticClass: "class_pic1",
      style: ({
        backgroundImage: 'url(' + teamitem.coverPictureUrl + ')'
      })
    }, [_c('div', {
      staticClass: "class_title"
    }, [_vm._v(_vm._s(_vm.showName(teamitem)))])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "teams": _vm.teams
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1243:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "signup"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "ca_title"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.className) + " " + _vm._s(_vm.classTypeName(_vm.admission)) + " " + _vm._s(_vm.admission.classHour) + " " + _vm._s(_vm.showPage.application))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "team2_mbox"
  }, [_c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.name))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.name),
      expression: "recordToEdit.name"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.sex) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.sex),
      expression: "recordToEdit.sex"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.sex, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "sex", "1")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.male) + "\n              "), _c('span', {
    staticClass: "ml20 mr20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.sex),
      expression: "recordToEdit.sex"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.sex, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "sex", "0")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.female))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.sex),
      expression: "recordToEdit.sex"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.sex, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "sex", "2")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.unkown) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.ID))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.idNo),
      expression: "recordToEdit.idNo"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.idNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "idNo", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.birthday))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('DatePicker', {
    staticStyle: {
      "width": "110px"
    },
    attrs: {
      "type": "date",
      "placeholder": "出生年月日",
      "value": _vm.recordToEdit.birthday
    },
    on: {
      "on-change": _vm.dateChange
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.parent))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.parentsName),
      expression: "recordToEdit.parentsName"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.parentsName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "parentsName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.serviceunits))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.serviceUnit),
      expression: "recordToEdit.serviceUnit"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.serviceUnit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "serviceUnit", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.tel))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.tel),
      expression: "recordToEdit.tel"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.tel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "tel", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.mobile))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.mobile),
      expression: "recordToEdit.mobile"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.email),
      expression: "recordToEdit.email"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v(_vm._s(_vm.showPage.address))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.address),
      expression: "recordToEdit.address"
    }],
    staticClass: "sign_inp3",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.classtype) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.memberType),
      expression: "recordToEdit.memberType"
    }],
    attrs: {
      "type": "radio",
      "name": "",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.memberType, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "memberType", "1")
      }
    }
  }), _vm._v(_vm._s(_vm.showPage.adult) + "\n              "), _c('span', {
    staticClass: "ml20 mr20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.memberType),
      expression: "recordToEdit.memberType"
    }],
    attrs: {
      "type": "radio",
      "name": "",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.memberType, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "memberType", "2")
      }
    }
  }), _vm._v(_vm._s(_vm.showPage.child) + "\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.charges) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.chargesType),
      expression: "recordToEdit.chargesType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.chargesType, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "chargesType", "1")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.onCampus) + "  "), _c('spen', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admission.charges1 && _vm.admission.charges1 > 0),
      expression: "admission.charges1 && admission.charges1 > 0 "
    }]
  }, [_vm._v("$" + _vm._s(_vm.admission.charges1))]), _vm._v(" "), _c('span', {
    staticClass: "ml20 mr20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.chargesType),
      expression: "recordToEdit.chargesType"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.chargesType, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "chargesType", "2")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.offCampus) + " "), _c('spen', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.admission.charges2 && _vm.admission.charges2 > 0),
      expression: "admission.charges2 && admission.charges2 > 0 "
    }]
  }, [_vm._v("$" + _vm._s(_vm.admission.charges2))])], 1)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "w_box"
  }, [_vm._v(_vm._s(_vm.showPage.applynote))]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.classWeek) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "1") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.mon) + "\n              "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "2") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.tue))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "3") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.wed))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "4") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.thu))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "5") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.fri))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "6") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.sat))]), _vm._v(" "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classWeek),
      expression: "recordToEdit.classWeek"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classWeek) ? _vm._i(_vm.recordToEdit.classWeek, "7") > -1 : (_vm.recordToEdit.classWeek)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classWeek,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classWeek = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classWeek = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classWeek", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.sun))])])])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.classcount))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('InputNumber', {
    staticStyle: {
      "width": "50px",
      "margin": "0 4px"
    },
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.recordToEdit.classCount),
      callback: function($$v) {
        _vm.$set(_vm.recordToEdit, "classCount", $$v)
      },
      expression: "recordToEdit.classCount"
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.lesson) + "\n          ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.classtime))]), _vm._v(" "), _c('div', {
    staticClass: "siup_l"
  }, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "1") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" 17：00～18：00\n              "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "2") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" 18：00～19：00")])]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "3") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" 19：00～20：00\n              "), _c('span', {
    staticClass: "ml20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "4") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" 20：00～21：00")])]), _vm._v(" "), _c('div', {
    staticClass: "mt10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTime),
      expression: "recordToEdit.classTime"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.recordToEdit.classTime) ? _vm._i(_vm.recordToEdit.classTime, "5") > -1 : (_vm.recordToEdit.classTime)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.recordToEdit.classTime,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.recordToEdit.classTime = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.recordToEdit.classTime = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.recordToEdit, "classTime", $$c)
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.other) + "\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.classTimeOther),
      expression: "recordToEdit.classTimeOther"
    }],
    staticClass: "sign_inp4",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.classTimeOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "classTimeOther", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "siup_box"
  }, [_c('div', {
    staticClass: "siup_l"
  }, [_vm._v(_vm._s(_vm.showPage.coachrequirements) + "\n            "), _c('div', {
    staticClass: "siup_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.coach),
      expression: "recordToEdit.coach"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.coach, "1")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "coach", "1")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.coachMale) + "\n              "), _c('span', {
    staticClass: "ml20 mr20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.coach),
      expression: "recordToEdit.coach"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "0"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.coach, "0")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "coach", "0")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.coachFeMale))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.coach),
      expression: "recordToEdit.coach"
    }],
    attrs: {
      "name": "",
      "type": "radio",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.recordToEdit.coach, "2")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.recordToEdit, "coach", "2")
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.coachSpecified) + "\n              "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.recordToEdit.coachOther),
      expression: "recordToEdit.coachOther"
    }],
    staticClass: "sign_inp4",
    attrs: {
      "name": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.recordToEdit.coachOther)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.recordToEdit, "coachOther", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "w_box"
  }, [_vm._v(_vm._s(_vm.admission.memo))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agree),
      expression: "agree"
    }],
    attrs: {
      "name": "",
      "type": "checkbox",
      "value": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.agree) ? _vm._i(_vm.agree, "") > -1 : (_vm.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agree = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.agree = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agree = $$c
        }
      }
    }
  }), _vm._v(" " + _vm._s(_vm.showPage.agree) + "\n        "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.saveData
    }
  }, [_vm._v(_vm._s(_vm.showPage.signup))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "siup_l"
  }, [_c('i', {
    staticClass: "require"
  }), _vm._v("Email")])
}]}

/***/ }),

/***/ 1246:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_research"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 4) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n          " + _vm._s(teacherpublication.context) + "\n        ")]) : _c('span', [(_vm.executiveDateS(teacherpublication)) ? _c('span', [_vm._v(_vm._s(_vm.executiveDateS(teacherpublication)) + " ~ " + _vm._s(_vm.executiveDateE(teacherpublication)) + ", ")]) : _vm._e(), _vm._v(" " + _vm._s(_vm.showName(teacherpublication)) + ", "), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.memo) + ")")]) : _vm._e()])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 1247:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "member"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1252:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "coach_info"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "ca_title"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.className) + " " + _vm._s(_vm.showPage.coach_info_title))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_item',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_item))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'facility',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_inside',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })]), _vm._v(" "), _vm._l((_vm.coachs), function(coach, index) {
    return _c('div', {
      key: index,
      staticClass: "coach_box"
    }, [_c('div', {
      staticClass: "coach_l"
    }, [(coach.profileImage) ? _c('img', {
      attrs: {
        "src": coach.profileImage
      }
    }) : _c('img', {
      attrs: {
        "src": "/../static/images/timeline-default-photo.gif"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "coach_r"
    }, [_c('ul', [_c('li', [_vm._v(_vm._s(_vm.showPage.name) + " : " + _vm._s(_vm.showName(coach)))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.showPage.sex) + " : " + _vm._s(_vm.showSex(coach.sex)))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.showPage.license) + " : "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.showLicense(coach))
      }
    })]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.showPage.history) + " : "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.showHistory(coach))
      }
    })])])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1254:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "site"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.sites), function(site, index) {
    return (site.trash !== 1) ? _c('div', {
      key: index,
      staticStyle: {
        "padding": "10px 10px 10px 25px"
      }
    }, [_c('a', {
      staticClass: "site_link",
      on: {
        "click": function($event) {
          _vm.pushToSite(index)
        }
      }
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(_vm.showName(site)))])]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "sites": _vm.sites
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "site_pic"
  }, [_c('img', {
    attrs: {
      "src": "/../static/images/u19394.jpg"
    }
  })])])
}]}

/***/ }),

/***/ 1257:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_info"
    }
  }, [_c('div', {
    staticClass: "tea_r"
  }, [_c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_basic'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.personalInformation))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_edu'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.educationCourses))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "tea_hnav"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'teacher_prize'
      }
    }
  }, [_c('button', {
    staticClass: "teah_btn",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.showPage.awardsExperiences))])])], 1), _vm._v(" "), _vm._l((_vm.customs), function(custom, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_hnav"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'teacher_custom',
          params: {
            custom: index
          }
        }
      }
    }, [_c('button', {
      staticClass: "teah_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v(_vm._s(_vm.showName(custom)))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('router-view', {
    attrs: {
      "teacher": _vm.info,
      "teacherpublications": _vm.teacherpublications,
      "customs": _vm.customs
    }
  })], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 1260:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page"
    }
  }, [(!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "40px",
      "margin-left": "-10px"
    },
    domProps: {
      "innerHTML": _vm._s((_vm.Page.title))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.allContent)
    }
  })])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1261:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "class_inside"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "psear mb10"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_item',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_item))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'coach_info',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.coach_info))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'facility',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fix",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showNote())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1262:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher"
    }
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_l"
  }, [_c('div', {
    staticClass: "tea_nav_title"
  }, [_vm._v(_vm._s(_vm.showPage.collegeMember))]), _vm._v(" "), _c('div', {
    staticClass: "tea_nav"
  }, [_c('ul', [_c('li', {
    class: _vm.on[11],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(11);
        _vm.selectTitle(11);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.honoraryProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[1],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(1);
        _vm.selectTitle(1);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.professor))]), _vm._v(" "), _c('li', {
    class: _vm.on[2],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(2);
        _vm.selectTitle(2);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.associateProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[3],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(3);
        _vm.selectTitle(3);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.assistantProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[5],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(5);
        _vm.selectTitle(5);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.fullTimeLecturer))]), _vm._v(" "), _c('li', {
    class: _vm.on[6],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(6);
        _vm.selectTitle(6);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[7],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(7);
        _vm.selectTitle(7);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctAssociateProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[8],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(8);
        _vm.selectTitle(8);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctAssistantProfessor))]), _vm._v(" "), _c('li', {
    class: _vm.on[9],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(9);
        _vm.selectTitle(9);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.adjunctLecture))]), _vm._v(" "), _c('li', {
    class: _vm.on[10],
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.focus(10);
        _vm.selectTitle(10);
        _vm.pushToTeacher();
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.teachingAssistant))])])])]), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "tea_r"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showTitle()))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "tea_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.teacherSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "tea_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("GO")])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mt15"
  }, _vm._l((_vm.teachers), function(teacher, index) {
    return (teacher.dept === 1 || teacher.dept === 2) ? _c('div', {
      key: index,
      staticClass: "tea_m"
    }, [_vm._v("\n          " + _vm._s(_vm.returnDept(teacher.dept)) + " / "), _c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher)
        }
      }
    }, [_vm._v(_vm._s(teacher.nameCh))])]) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_g"
  }, [_vm._v(_vm._s(_vm.showPage.teacherMemberCount) + " " + _vm._s(_vm.teachers.length) + " " + _vm._s(_vm.showPage.people))]), _vm._v(" "), _c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li"
  }, _vm._l((_vm.teachers), function(teacher, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "tea_li_l"
    }, [(teacher.profileImage) ? _c('img', {
      attrs: {
        "src": teacher.profileImage
      }
    }) : _c('img', {
      attrs: {
        "src": "/../static/images/timeline-default-photo.gif"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "tea_li_r"
    }, [_c('div', {
      staticClass: "tea_lititle"
    }, [_vm._v(_vm._s(teacher.nameEn) + " " + _vm._s(teacher.nameCh))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showTitle()))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(teacher.office) + " / " + _vm._s(teacher.tel) + " / " + _vm._s(teacher.email))]), _vm._v(" "), _c('div', {
      staticClass: "tea_tx"
    }, [_vm._v("Office Hour : " + _vm._s(teacher.advisory))]), _vm._v(" "), _c('div', {
      staticClass: "tea_p"
    }, [_c('ul', [_c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 0)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.personalInformation))])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 1)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.educationCourses))])]), _vm._v(" "), _c('li', [_c('a', {
      on: {
        "click": function($event) {
          _vm.pushToInfo(teacher, 2)
        }
      }
    }, [_vm._v(_vm._s(_vm.showPage.awardsExperiences))])]), _vm._v(" "), _vm._l((_vm.teachercustoms(teacher)), function(custom, index) {
      return _c('li', {
        key: index
      }, [_c('router-link', {
        attrs: {
          "to": {
            name: 'teacher_custom',
            params: {
              custom: index,
              teacherid: teacher.id
            }
          }
        }
      }, [_vm._v("\n                      " + _vm._s(_vm.showName(custom)) + "\n                    ")])], 1)
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.teachers.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "teacher": _vm.teacher
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 1)])
},staticRenderFns: []}

/***/ }),

/***/ 1268:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "class"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_one"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_c('div', {
    staticClass: "tx_box",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "boxall"
  }, [_vm._l((_vm.classes), function(classitem, index) {
    return _c('div', {
      key: index,
      on: {
        "click": function($event) {
          _vm.selectClass(classitem)
        }
      }
    }, [_c('div', {
      staticClass: "box2"
    }, [_c('div', {
      staticClass: "class_box"
    }, [_c('div', {
      staticClass: "class_pic1",
      style: ({
        background: 'url(' + classitem.pictureUrl + ')'
      })
    }, [_c('div', {
      staticClass: "class_title"
    }, [_vm._v(_vm._s(_vm.showName(classitem)))])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "tx_box mt20",
    domProps: {
      "innerHTML": _vm._s(_vm.showApplication())
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "classitem": _vm.nowClassitem
    },
    on: {
      "initClass": _vm.initClass
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1279:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team_type"
    }
  }, [(_vm.$route.meta.keepAliveSub3) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "psear mb10",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "photo_box"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'photo_in',
          params: {
            albumId: album.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_icon"
    }, [_vm._v("\n            " + _vm._s(_vm.showMemo(album)) + "\n            "), _c('div', {
      staticClass: "mt10"
    }, [_c('button', {
      staticClass: "photo_btn",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("more")])])]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": album.coverPictureUrl
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_title"
    }, [_vm._v(_vm._s(_vm.showName(album)))]), _vm._v(" "), _c('div', {
      staticClass: "photo_box_tx"
    }, [_vm._v(_vm._s(_vm.showPage.totalCount) + _vm._s(album.pictureCount) + _vm._s(_vm.showPage.item))])])], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })], 2)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),

/***/ 1281:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_seminar"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 1) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n          " + _vm._s(teacherpublication.context) + "\n        ")]) : _c('span', [_c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.author))
      }
    }), _vm._v(", " + _vm._s(_vm.publication(teacherpublication)) + ",\n          "), _c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.title))
      }
    }), _vm._v(", " + _vm._s(_vm.showName(teacherpublication)) + ", " + _vm._s(_vm.publicationmonth(teacherpublication)) + ",\n          "), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.place) + "), ")]) : _vm._e(), (teacherpublication.memo) ? _c('span', [_vm._v("(" + _vm._s(teacherpublication.memo) + ")")]) : _vm._e()])]) : _vm._e()
  }))])])
},staticRenderFns: []}

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "news"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_l"
  }, [_c('div', {
    staticClass: "tea_nav_title"
  }, [_vm._v(_vm._s(_vm.newsTitle))]), _vm._v(" "), _c('div', {
    staticClass: "tea_nav"
  }, [_c('ul', _vm._l((_vm.types), function(type, index) {
    return (type.homeDisplay === 1) ? _c('li', {
      key: index,
      class: _vm.on[type.id],
      on: {
        "click": function($event) {
          _vm.focus(type.id);
          _vm.selectName(type.id);
          _vm.pushToNew();
        }
      }
    }, [_vm._v(_vm._s(_vm.showType(type)))]) : _vm._e()
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r",
    staticStyle: {
      "position": "relative"
    }
  }, [_vm._l((_vm.hotNews), function(newsitem, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: 'hot' + index,
      staticClass: "more_box"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(newsitem),
        "href": _vm.href(newsitem)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(newsitem)
        }
      }
    }, [_c('div', {
      staticClass: "more_l"
    }, [_vm._v("\n              " + _vm._s(newsitem.createdAt.split(' ')[0]) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "more_r"
    }, [_c('span', {
      staticClass: "nhott"
    }, [_vm._v("HOT")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(newsitem.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.normalNews), function(newsitem, index) {
    return (_vm.inCurrentPage(_vm.hotNews.length + index)) ? _c('div', {
      key: index,
      staticClass: "more_box"
    }, [_c('a', {
      attrs: {
        "target": _vm.target(newsitem),
        "href": _vm.href(newsitem)
      },
      on: {
        "click": function($event) {
          _vm.pushToNewsSub(newsitem)
        }
      }
    }, [_c('div', {
      staticClass: "more_l"
    }, [_vm._v("\n              " + _vm._s(newsitem.createdAt.split(' ')[0]) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "more_r"
    }, [_c('span', [_vm._v(_vm._s(newsitem.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "fix"
    })]) : _vm._e()
  }), _vm._v(" "), (_vm.spinShow) ? _c('Spin', {
    staticStyle: {
      "margin-top": "100px"
    },
    attrs: {
      "size": "large",
      "fix": ""
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.news.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('router-view', {
    attrs: {
      "newsitem": _vm.newsitem
    },
    on: {
      "initNews": _vm.initNews
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1287:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "team"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), (_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showIntroduction())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_mbox"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'team_type',
        params: {
          teamtypeid: 1
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.menTeam))])], 1), _vm._v(" "), _c('div', {
    staticClass: "team_mbox2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'team_type',
        params: {
          teamtypeid: 0
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.showPage.womenTeam))])], 1), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])]) : _vm._e(), _vm._v(" "), _c('router-view', {
    attrs: {
      "teams": _vm.teams
    }
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1293:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_book"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', [_c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('ul', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, _vm._l((_vm.teacherpublications), function(teacherpublication, index) {
    return (teacherpublication.type === 3) ? _c('li', {
      key: index,
      staticStyle: {
        "list-style": "inside"
      }
    }, [(teacherpublication.context) ? _c('span', [_vm._v("\n            " + _vm._s(teacherpublication.context) + "\n          ")]) : _c('span', [_c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.author))
      }
    }), _vm._v(", " + _vm._s(_vm.publication(teacherpublication)) + ",\n            "), _c('div', {
      staticStyle: {
        "display": "inline-block"
      },
      attrs: {
        "aria-hidden": "true"
      },
      domProps: {
        "innerHTML": _vm._s((teacherpublication.title))
      }
    }), _vm._v(", " + _vm._s(_vm.showName(teacherpublication)) + "\n          ")])]) : _vm._e()
  }))])])])
},staticRenderFns: []}

/***/ }),

/***/ 1295:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "journal_content"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('p', {
    staticStyle: {
      "border-left": "3px solid #bbb",
      "padding-left": "10px",
      "font-size": "20px"
    }
  }, [_vm._v(_vm._s(_vm.showName(_vm.type)))]), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.showPage.fileName))])]), _vm._v(" "), _vm._l((_vm.journals), function(journal, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('a', {
      attrs: {
        "href": journal.fileUrl,
        "download": ""
      }
    }, [_c('div', [_vm._v(_vm._s(journal.title))])])])])
  })], 2)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1296:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "video"
    }
  }, [_c('div', {
    staticClass: "break_box"
  }, [_c('Breadcrumb', [_c('breadcrumbs')], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": _vm.nowTitle,
      "class-name": "vertical-center-modal-video"
    },
    model: {
      value: (_vm.modalvideo),
      callback: function($$v) {
        _vm.modalvideo = $$v
      },
      expression: "modalvideo"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#f60",
      "text-align": "center",
      "margin": "0"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('iframe', {
    attrs: {
      "width": "560",
      "height": "315",
      "src": _vm.nowVideo,
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })]), _vm._v(" "), (!_vm.$route.meta.keepAliveSub) ? _c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_two"
  }, [_c('div', {
    staticClass: "tea_r_l"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchName),
      expression: "searchName"
    }],
    staticClass: "psear_input",
    attrs: {
      "name": "",
      "type": "text",
      "placeholder": _vm.showPage.videoSearch
    },
    domProps: {
      "value": (_vm.searchName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "gue_btn",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm.showPage.search))])]), _vm._v(" "), _c('div', {
    staticClass: "tea_r_r"
  }, [_c('span', {
    staticClass: "ca2_btn"
  }, [_vm._v(_vm._s(_vm.showPage.orderByReleaseDate))])]), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _vm._l((_vm.videos), function(video, index) {
    return (_vm.inCurrentPage(index)) ? _c('div', {
      key: index,
      staticClass: "photo_box",
      on: {
        "click": function($event) {
          _vm.selectVideo(video)
        }
      }
    }, [_c('div', {
      staticClass: "photo_box_pic"
    }, [_c('img', {
      attrs: {
        "src": video.coverPictureUrl
      }
    })])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  }), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": _vm.videos.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)], 2)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 1303:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "teacher_edu"
    }
  }, [_c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "tea_li",
    staticStyle: {
      "margin-bottom": "40px"
    }
  }, [_c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.education))]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.backgroundColumn,
      "data": _vm.teacher.background
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tea_title"
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-down mr5",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.showPage.course))]), _vm._v(" "), _vm._l((_vm.teacher.course), function(course, index) {
    return _c('div', {
      key: index,
      staticClass: "tea_tx"
    }, [_vm._v(_vm._s(_vm.showCourse(course)))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 1316:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "facility"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box2"
  }, [_c('div', {
    staticClass: "psear mb10"
  }, [_c('div', {
    staticClass: "ca_l"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.facility))])]), _vm._v(" "), _c('div', {
    staticClass: "ca_l"
  }, [_c('div', {
    staticClass: "ca_r"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_item',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_item))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'coach_info',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.coach_info))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ca_r2"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'class_inside',
        params: {
          classname: _vm.className
        }
      }
    }
  }, [_c('button', {
    staticClass: "ca_btn"
  }, [_vm._v(_vm._s(_vm.showPage.class_inside))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "fix",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team_bbox",
    domProps: {
      "innerHTML": _vm._s(_vm.showSite())
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fix"
  })])])])
},staticRenderFns: []}

/***/ }),

/***/ 1323:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "administrative"
    }
  }, [_c('div', {
    staticClass: "con_all"
  }, [_c('div', {
    staticClass: "con_box"
  }, [_c('span', {
    staticClass: "con_title con_title_line"
  }, [_vm._v(_vm._s(_vm.showPage.administrativeMember))]), _vm._v(" "), _c('div', {
    staticClass: "over_ta"
  }, [_c('div', {
    staticClass: "con_ta"
  }, [_c('table', [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "140"
    }
  }, [_vm._v(" ")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "103"
    }
  }, [_vm._v(_vm._s(_vm.showPage.jobTitle))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "110"
    }
  }, [_vm._v(_vm._s(_vm.showPage.activityGroup))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "103"
    }
  }, [_vm._v(_vm._s(_vm.showPage.name))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "149"
    }
  }, [_vm._v(_vm._s(_vm.showPage.officePhone))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "385"
    }
  }, [_vm._v(_vm._s(_vm.showPage.business))]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "156"
    }
  }, [_vm._v(_vm._s(_vm.showPage.agent))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.admins), function(admin, index) {
    return (_vm.inCurrentPage(index)) ? _c('tr', {
      key: index
    }, [(admin.profileImage) ? _c('td', {
      staticClass: "mobile-img"
    }, [_c('img', {
      attrs: {
        "src": admin.profileImage
      }
    })]) : _vm._e(), _vm._v(" "), (!admin.profileImage) ? _c('td', {
      staticClass: "mobile-img"
    }, [_c('img', {
      attrs: {
        "src": "/../static/images/timeline-default-photo.gif"
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.jobTitle
      }
    }, [_vm._v(_vm._s(_vm.showJobTitle(admin)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.activityGroup
      }
    }, [_vm._v(_vm._s(_vm.showGroup(admin)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.name
      }
    }, [_vm._v(_vm._s(_vm.showName(admin)))]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.officePhone
      }
    }, [_vm._v(_vm._s(admin.tel))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "left"
      },
      attrs: {
        "data-label": _vm.showPage.business
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.showIntroduction(admin))
      }
    })]), _vm._v(" "), _c('td', {
      attrs: {
        "data-label": _vm.showPage.agent
      }
    }, [_vm._v(_vm._s(admin.agent))])]) : _vm._e()
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "pagination-row text-center ml20"
  }, [_c('Page', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "total": _vm.admins.length,
      "page-size": _vm.pagesize
    },
    on: {
      "on-change": _vm.changePage
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),

/***/ 1329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {var animate_type = 'up'; //up or left or fadeout
var sec = 0.3; //0.5秒
var nav_box_setting = ['.cell_nav_box', '.cell_nav_open_btn', '.cell_nav_close_btn', animate_type, sec];
var nav_box_offset
var obj
var obj_close
var check
var move


$().ready(function() {
  nav_box(nav_box_setting);
  $(' #da-thumbs > li ').each(function() { $(this).hoverdir(); });
});

var cx = '005583908390302854516:faepp2qgog8';
var gcse = document.createElement('script');
gcse.type = 'text/javascript';
gcse.async = true;
gcse.src = 'https://cse.google.com/cse.js?cx=' + cx;
var s = document.getElementsByTagName('script')[0];
s.parentNode.insertBefore(gcse, s);

function nav_box(nav_box_setting, animate) {
  nav_box_offset = 20;
  if (!nav_box_setting) return;

  obj = $(nav_box_setting[0]);
  obj_close = $(nav_box_setting[0]);
  animate_type = nav_box_setting[3];
  sec = nav_box_setting[4] * 1000;

  if (animate != 'Y') {
    if (animate_type == 'left') $(nav_box_setting[0]).css({ 'position': 'fixed', 'left': ($(this).width() * -1 - nav_box_offset) });
    if (animate_type == 'up') $(nav_box_setting[0]).css({ 'position': 'fixed', 'top': $(this).height() * -1 - nav_box_offset });
    if (animate_type == 'fadeout') $(nav_box_setting[0]).css({ 'position': 'fixed' }).hide();
    $(nav_box_setting[1]).on('click', function() { nav_box(nav_box_setting, 'Y') });
    $(nav_box_setting[2]).on('click', function() { nav_box(nav_box_setting, 'Y') });
    $('.clicknav').on('click', function() { nav_box(nav_box_setting, 'Y') });
    return;
  }

  check = false;
  if (animate_type == 'left' && parseInt(obj.css('left')) < 0) check = true;
  if (animate_type == 'up' && parseInt(obj.css('top')) < 0) check = true;
  if (animate_type == 'fadeout' && obj.css('display') == 'none') check = true;

  if (check) {
    //OPEN鈕效果
    //$(nav_box_setting[1]).hide();
    if (animate_type == 'left') obj.animate({ left: 0 }, sec);
    if (animate_type == 'up') obj.animate({ top: 84 }, sec);
    if (animate_type == 'fadeout') obj.fadeIn(sec);
  } else {
    if (animate_type == 'left') {
      move = obj.width() + nav_box_offset;
      obj.animate({ left: move * -1 }, sec);
    }

    if (animate_type == 'up') {
      move = obj.height() + nav_box_offset;
      obj.animate({ top: move * -1 }, sec);
    }
    if (animate_type == 'fadeout') obj.fadeOut(sec);

    //OPEN鈕效果
    //setTimeout(function(){$(nav_box_setting[1]).show();},sec);
  }
}

// $(function() {
//   SyntaxHighlighter.all();
// });

/* harmony default export */ __webpack_exports__["a"] = ({ //export your file
  init: function() {
    $('.clone').remove()
    $('.flexslider').flexslider({
      animation: "slide",
    });
    $('#carousel-example-generic').carousel({
      interval: 4000
    });

  },
  destroy: function() {
    $('.clone').remove()
  },
  test: function() {
    nav_box(nav_box_setting);
  }
});
$(window).on('load', function() {
  $('.flexslider').flexslider({
    animation: "slide",
    start: function(slider) {
      $('body').removeClass('loading');
    }
  });
})
// 若在mounted使用init()輪播圖片大小有變成超大的可能
//　所以額外使用load

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var defer = function defer() {
  var state = false; // Resolved or not
  var callbacks = [];
  var resolve = function resolve(val) {
    if (state) {
      return;
    }

    state = true;
    for (var i = 0, len = callbacks.length; i < len; i++) {
      callbacks[i](val);
    }
  };

  var then = function then(cb) {
    if (!state) {
      callbacks.push(cb);
      return;
    }
    cb();
  };

  var deferred = {
    resolved: function resolved() {
      return state;
    },

    resolve: resolve,
    promise: {
      then: then
    }
  };
  return deferred;
};

function createRecaptcha() {
  var deferred = defer();

  return {
    notify: function notify() {
      deferred.resolve();
    },
    wait: function wait() {
      return deferred.promise;
    },
    render: function render(ele, options, cb) {
      this.wait().then(function () {
        cb(window.grecaptcha.render(ele, options));
      });
    },
    reset: function reset(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.reset(widgetId);
      });
    },
    execute: function execute(widgetId) {
      if (typeof widgetId === 'undefined') {
        return;
      }

      this.assertLoaded();
      this.wait().then(function () {
        return window.grecaptcha.execute(widgetId);
      });
    },
    checkRecaptchaLoad: function checkRecaptchaLoad() {
      if (window.hasOwnProperty('grecaptcha')) {
        this.notify();
      }
    },
    assertLoaded: function assertLoaded() {
      if (!deferred.resolved()) {
        throw new Error('ReCAPTCHA has not been loaded');
      }
    }
  };
}

var recaptcha = createRecaptcha();

if (typeof window !== 'undefined') {
  window.vueRecaptchaApiLoaded = recaptcha.notify;
}

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var VueRecaptcha$1 = {
  name: 'VueRecaptcha',
  props: {
    sitekey: {
      type: String,
      required: true
    },
    theme: {
      type: String
    },
    badge: {
      type: String
    },
    type: {
      type: String
    },
    size: {
      type: String
    },
    tabindex: {
      type: String
    }
  },
  mounted: function mounted() {
    var _this = this;

    recaptcha.checkRecaptchaLoad();
    var opts = _extends({}, this.$props, {
      callback: this.emitVerify,
      'expired-callback': this.emitExpired
    });
    var container = this.$slots.default ? this.$el.children[0] : this.$el;
    recaptcha.render(container, opts, function (id) {
      _this.$widgetId = id;
      _this.$emit('render', id);
    });
  },

  methods: {
    reset: function reset() {
      recaptcha.reset(this.$widgetId);
    },
    execute: function execute() {
      recaptcha.execute(this.$widgetId);
    },
    emitVerify: function emitVerify(response) {
      this.$emit('verify', response);
    },
    emitExpired: function emitExpired() {
      this.$emit('expired');
    }
  },
  render: function render(h) {
    return h('div', {}, this.$slots.default);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (VueRecaptcha$1);


/***/ }),

/***/ 245:
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated via the `commonjs` Grunt task. You can require() this file in a CommonJS environment.
__webpack_require__(268)
__webpack_require__(261)
__webpack_require__(262)
__webpack_require__(263)
__webpack_require__(264)
__webpack_require__(70)
__webpack_require__(71)
__webpack_require__(72)
__webpack_require__(265)
__webpack_require__(266)
__webpack_require__(267)
__webpack_require__(260)

/***/ }),

/***/ 246:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 257:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: affix.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#affix
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    var target = this.options.target === Affix.DEFAULTS.target ? $(this.options.target) : $(document).find(this.options.target)

    this.$target = target
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.4.1'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 261:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: alert.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.4.1'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    selector    = selector === '#' ? [] : selector
    var $parent = $(document).find(selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: button.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.4.1'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: carousel.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.4.1'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      if (typeof $next === 'object' && $next.length) {
        $next[0].offsetWidth // force reflow
      }
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    if (href) {
      href = href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
    }

    var target  = $this.attr('data-target') || href
    var $target = $(document).find(target)

    if (!$target.hasClass('carousel')) return

    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: collapse.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.4.1'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(document).find(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(document).find(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: popover.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.4.1'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    if (this.options.html) {
      var typeContent = typeof content

      if (this.options.sanitize) {
        title = this.sanitizeHtml(title)

        if (typeContent === 'string') {
          content = this.sanitizeHtml(content)
        }
      }

      $tip.find('.popover-title').html(title)
      $tip.find('.popover-content').children().detach().end()[
        typeContent === 'string' ? 'html' : 'append'
      ](content)
    } else {
      $tip.find('.popover-title').text(title)
      $tip.find('.popover-content').children().detach().end().text(content)
    }

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
        o.content.call($e[0]) :
        o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: scrollspy.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.4.1'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 267:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tab.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.4.1'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(document).find(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
        .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
        .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
          .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: transition.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // https://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 290:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 299:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(290)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(257),
  /* template */
  __webpack_require__(300),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 300:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page-not-found"
    }
  }, [_c('div', [_c('h1', [_vm._v("Error 404")]), _vm._v(" "), _c('p', [_vm._v("Page not found")])])])
}]}

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery, setImmediate) {/*
 * jQuery FlexSlider v2.6.4
 * Copyright 2012 WooThemes
 * Contributing Author: Tyler Smith
 */
;
(function ($) {

  var focused = true;

  //FlexSlider: Object Instance
  $.flexslider = function(el, options) {
    var slider = $(el);

    // making variables public
    slider.vars = $.extend({}, $.flexslider.defaults, options);

    var namespace = slider.vars.namespace,
        msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
        touch = (( "ontouchstart" in window ) || msGesture || window.DocumentTouch && document instanceof DocumentTouch) && slider.vars.touch,
        // deprecating this idea, as devices are being released with both of these events
        eventType = "click touchend MSPointerUp keyup",
        watchedEvent = "",
        watchedEventClearTimer,
        vertical = slider.vars.direction === "vertical",
        reverse = slider.vars.reverse,
        carousel = (slider.vars.itemWidth > 0),
        fade = slider.vars.animation === "fade",
        asNav = slider.vars.asNavFor !== "",
        methods = {};

    // Store a reference to the slider object
    $.data(el, "flexslider", slider);

    // Private slider methods
    methods = {
      init: function() {
        slider.animating = false;
        // Get current slide and make sure it is a number
        slider.currentSlide = parseInt( ( slider.vars.startAt ? slider.vars.startAt : 0), 10 );
        if ( isNaN( slider.currentSlide ) ) { slider.currentSlide = 0; }
        slider.animatingTo = slider.currentSlide;
        slider.atEnd = (slider.currentSlide === 0 || slider.currentSlide === slider.last);
        slider.containerSelector = slider.vars.selector.substr(0,slider.vars.selector.search(' '));
        slider.slides = $(slider.vars.selector, slider);
        slider.container = $(slider.containerSelector, slider);
        slider.count = slider.slides.length;
        // SYNC:
        slider.syncExists = $(slider.vars.sync).length > 0;
        // SLIDE:
        if (slider.vars.animation === "slide") { slider.vars.animation = "swing"; }
        slider.prop = (vertical) ? "top" : "marginLeft";
        slider.args = {};
        // SLIDESHOW:
        slider.manualPause = false;
        slider.stopped = false;
        //PAUSE WHEN INVISIBLE
        slider.started = false;
        slider.startTimeout = null;
        // TOUCH/USECSS:
        slider.transitions = !slider.vars.video && !fade && slider.vars.useCSS && (function() {
          var obj = document.createElement('div'),
              props = ['perspectiveProperty', 'WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
          for (var i in props) {
            if ( obj.style[ props[i] ] !== undefined ) {
              slider.pfx = props[i].replace('Perspective','').toLowerCase();
              slider.prop = "-" + slider.pfx + "-transform";
              return true;
            }
          }
          return false;
        }());
        slider.ensureAnimationEnd = '';
        // CONTROLSCONTAINER:
        if (slider.vars.controlsContainer !== "") slider.controlsContainer = $(slider.vars.controlsContainer).length > 0 && $(slider.vars.controlsContainer);
        // MANUAL:
        if (slider.vars.manualControls !== "") slider.manualControls = $(slider.vars.manualControls).length > 0 && $(slider.vars.manualControls);

        // CUSTOM DIRECTION NAV:
        if (slider.vars.customDirectionNav !== "") slider.customDirectionNav = $(slider.vars.customDirectionNav).length === 2 && $(slider.vars.customDirectionNav);

        // RANDOMIZE:
        if (slider.vars.randomize) {
          slider.slides.sort(function() { return (Math.round(Math.random())-0.5); });
          slider.container.empty().append(slider.slides);
        }

        slider.doMath();

        // INIT
        slider.setup("init");

        // CONTROLNAV:
        if (slider.vars.controlNav) { methods.controlNav.setup(); }

        // DIRECTIONNAV:
        if (slider.vars.directionNav) { methods.directionNav.setup(); }

        // KEYBOARD:
        if (slider.vars.keyboard && ($(slider.containerSelector).length === 1 || slider.vars.multipleKeyboard)) {
          $(document).bind('keyup', function(event) {
            var keycode = event.keyCode;
            if (!slider.animating && (keycode === 39 || keycode === 37)) {
              var target = (keycode === 39) ? slider.getTarget('next') :
                           (keycode === 37) ? slider.getTarget('prev') : false;
              slider.flexAnimate(target, slider.vars.pauseOnAction);
            }
          });
        }
        // MOUSEWHEEL:
        if (slider.vars.mousewheel) {
          slider.bind('mousewheel', function(event, delta, deltaX, deltaY) {
            event.preventDefault();
            var target = (delta < 0) ? slider.getTarget('next') : slider.getTarget('prev');
            slider.flexAnimate(target, slider.vars.pauseOnAction);
          });
        }

        // PAUSEPLAY
        if (slider.vars.pausePlay) { methods.pausePlay.setup(); }

        //PAUSE WHEN INVISIBLE
        if (slider.vars.slideshow && slider.vars.pauseInvisible) { methods.pauseInvisible.init(); }

        // SLIDSESHOW
        if (slider.vars.slideshow) {
          if (slider.vars.pauseOnHover) {
            slider.hover(function() {
              if (!slider.manualPlay && !slider.manualPause) { slider.pause(); }
            }, function() {
              if (!slider.manualPause && !slider.manualPlay && !slider.stopped) { slider.play(); }
            });
          }
          // initialize animation
          //If we're visible, or we don't use PageVisibility API
          if(!slider.vars.pauseInvisible || !methods.pauseInvisible.isHidden()) {
            (slider.vars.initDelay > 0) ? slider.startTimeout = setTimeout(slider.play, slider.vars.initDelay) : slider.play();
          }
        }

        // ASNAV:
        if (asNav) { methods.asNav.setup(); }

        // TOUCH
        if (touch && slider.vars.touch) { methods.touch(); }

        // FADE&&SMOOTHHEIGHT || SLIDE:
        if (!fade || (fade && slider.vars.smoothHeight)) { $(window).bind("resize orientationchange focus", methods.resize()); }

        slider.find("img").attr("draggable", "false");

        // API: start() Callback
        setTimeout(function(){
          slider.vars.start(slider);
        }, 200);
      },
      asNav: {
        setup: function() {
          slider.asNav = true;
          slider.animatingTo = Math.floor(slider.currentSlide/slider.move);
          slider.currentItem = slider.currentSlide;
          slider.slides.removeClass(namespace + "active-slide").eq(slider.currentItem).addClass(namespace + "active-slide");
          if(!msGesture){
              slider.slides.on(eventType, function(e){
                e.preventDefault();
                var $slide = $(this),
                    target = $slide.index();
                var posFromLeft = $slide.offset().left - $(slider).scrollLeft(); // Find position of slide relative to left of slider container
                if( posFromLeft <= 0 && $slide.hasClass( namespace + 'active-slide' ) ) {
                  slider.flexAnimate(slider.getTarget("prev"), true);
                } else if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass(namespace + "active-slide")) {
                  slider.direction = (slider.currentItem < target) ? "next" : "prev";
                  slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                }
              });
          }else{
              el._slider = slider;
              slider.slides.each(function (){
                  var that = this;
                  that._gesture = new MSGesture();
                  that._gesture.target = that;
                  that.addEventListener("MSPointerDown", function (e){
                      e.preventDefault();
                      if(e.currentTarget._gesture) {
                        e.currentTarget._gesture.addPointer(e.pointerId);
                      }
                  }, false);
                  that.addEventListener("MSGestureTap", function (e){
                      e.preventDefault();
                      var $slide = $(this),
                          target = $slide.index();
                      if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass('active')) {
                          slider.direction = (slider.currentItem < target) ? "next" : "prev";
                          slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
                      }
                  });
              });
          }
        }
      },
      controlNav: {
        setup: function() {
          if (!slider.manualControls) {
            methods.controlNav.setupPaging();
          } else { // MANUALCONTROLS:
            methods.controlNav.setupManual();
          }
        },
        setupPaging: function() {
          var type = (slider.vars.controlNav === "thumbnails") ? 'control-thumbs' : 'control-paging',
              j = 1,
              item,
              slide;

          slider.controlNavScaffold = $('<ol class="'+ namespace + 'control-nav ' + namespace + type + '"></ol>');

          if (slider.pagingCount > 1) {
            for (var i = 0; i < slider.pagingCount; i++) {
              slide = slider.slides.eq(i);
              if ( undefined === slide.attr( 'data-thumb-alt' ) ) { slide.attr( 'data-thumb-alt', '' ); }
              var altText = ( '' !== slide.attr( 'data-thumb-alt' ) ) ? altText = ' alt="' + slide.attr( 'data-thumb-alt' ) + '"' : '';
              item = (slider.vars.controlNav === "thumbnails") ? '<img src="' + slide.attr( 'data-thumb' ) + '"' + altText + '/>' : '<a href="#">' + j + '</a>';
              if ( 'thumbnails' === slider.vars.controlNav && true === slider.vars.thumbCaptions ) {
                var captn = slide.attr( 'data-thumbcaption' );
                if ( '' !== captn && undefined !== captn ) { item += '<span class="' + namespace + 'caption">' + captn + '</span>'; }
              }
              slider.controlNavScaffold.append('<li>' + item + '</li>');
              j++;
            }
          }

          // CONTROLSCONTAINER:
          (slider.controlsContainer) ? $(slider.controlsContainer).append(slider.controlNavScaffold) : slider.append(slider.controlNavScaffold);
          methods.controlNav.set();

          methods.controlNav.active();

          slider.controlNavScaffold.delegate('a, img', eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              var $this = $(this),
                  target = slider.controlNav.index($this);

              if (!$this.hasClass(namespace + 'active')) {
                slider.direction = (target > slider.currentSlide) ? "next" : "prev";
                slider.flexAnimate(target, slider.vars.pauseOnAction);
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();

          });
        },
        setupManual: function() {
          slider.controlNav = slider.manualControls;
          methods.controlNav.active();

          slider.controlNav.bind(eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              var $this = $(this),
                  target = slider.controlNav.index($this);

              if (!$this.hasClass(namespace + 'active')) {
                (target > slider.currentSlide) ? slider.direction = "next" : slider.direction = "prev";
                slider.flexAnimate(target, slider.vars.pauseOnAction);
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        set: function() {
          var selector = (slider.vars.controlNav === "thumbnails") ? 'img' : 'a';
          slider.controlNav = $('.' + namespace + 'control-nav li ' + selector, (slider.controlsContainer) ? slider.controlsContainer : slider);
        },
        active: function() {
          slider.controlNav.removeClass(namespace + "active").eq(slider.animatingTo).addClass(namespace + "active");
        },
        update: function(action, pos) {
          if (slider.pagingCount > 1 && action === "add") {
            slider.controlNavScaffold.append($('<li><a href="#">' + slider.count + '</a></li>'));
          } else if (slider.pagingCount === 1) {
            slider.controlNavScaffold.find('li').remove();
          } else {
            slider.controlNav.eq(pos).closest('li').remove();
          }
          methods.controlNav.set();
          (slider.pagingCount > 1 && slider.pagingCount !== slider.controlNav.length) ? slider.update(pos, action) : methods.controlNav.active();
        }
      },
      directionNav: {
        setup: function() {
          var directionNavScaffold = $('<ul class="' + namespace + 'direction-nav"><li class="' + namespace + 'nav-prev"><a class="' + namespace + 'prev" href="#">' + slider.vars.prevText + '</a></li><li class="' + namespace + 'nav-next"><a class="' + namespace + 'next" href="#">' + slider.vars.nextText + '</a></li></ul>');

          // CUSTOM DIRECTION NAV:
          if (slider.customDirectionNav) {
            slider.directionNav = slider.customDirectionNav;
          // CONTROLSCONTAINER:
          } else if (slider.controlsContainer) {
            $(slider.controlsContainer).append(directionNavScaffold);
            slider.directionNav = $('.' + namespace + 'direction-nav li a', slider.controlsContainer);
          } else {
            slider.append(directionNavScaffold);
            slider.directionNav = $('.' + namespace + 'direction-nav li a', slider);
          }

          methods.directionNav.update();

          slider.directionNav.bind(eventType, function(event) {
            event.preventDefault();
            var target;

            if (watchedEvent === "" || watchedEvent === event.type) {
              target = ($(this).hasClass(namespace + 'next')) ? slider.getTarget('next') : slider.getTarget('prev');
              slider.flexAnimate(target, slider.vars.pauseOnAction);
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        update: function() {
          var disabledClass = namespace + 'disabled';
          if (slider.pagingCount === 1) {
            slider.directionNav.addClass(disabledClass).attr('tabindex', '-1');
          } else if (!slider.vars.animationLoop) {
            if (slider.animatingTo === 0) {
              slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "prev").addClass(disabledClass).attr('tabindex', '-1');
            } else if (slider.animatingTo === slider.last) {
              slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "next").addClass(disabledClass).attr('tabindex', '-1');
            } else {
              slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
            }
          } else {
            slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
          }
        }
      },
      pausePlay: {
        setup: function() {
          var pausePlayScaffold = $('<div class="' + namespace + 'pauseplay"><a href="#"></a></div>');

          // CONTROLSCONTAINER:
          if (slider.controlsContainer) {
            slider.controlsContainer.append(pausePlayScaffold);
            slider.pausePlay = $('.' + namespace + 'pauseplay a', slider.controlsContainer);
          } else {
            slider.append(pausePlayScaffold);
            slider.pausePlay = $('.' + namespace + 'pauseplay a', slider);
          }

          methods.pausePlay.update((slider.vars.slideshow) ? namespace + 'pause' : namespace + 'play');

          slider.pausePlay.bind(eventType, function(event) {
            event.preventDefault();

            if (watchedEvent === "" || watchedEvent === event.type) {
              if ($(this).hasClass(namespace + 'pause')) {
                slider.manualPause = true;
                slider.manualPlay = false;
                slider.pause();
              } else {
                slider.manualPause = false;
                slider.manualPlay = true;
                slider.play();
              }
            }

            // setup flags to prevent event duplication
            if (watchedEvent === "") {
              watchedEvent = event.type;
            }
            methods.setToClearWatchedEvent();
          });
        },
        update: function(state) {
          (state === "play") ? slider.pausePlay.removeClass(namespace + 'pause').addClass(namespace + 'play').html(slider.vars.playText) : slider.pausePlay.removeClass(namespace + 'play').addClass(namespace + 'pause').html(slider.vars.pauseText);
        }
      },
      touch: function() {
        var startX,
          startY,
          offset,
          cwidth,
          dx,
          startT,
          onTouchStart,
          onTouchMove,
          onTouchEnd,
          scrolling = false,
          localX = 0,
          localY = 0,
          accDx = 0;

        if(!msGesture){
            onTouchStart = function(e) {
              if (slider.animating) {
                e.preventDefault();
              } else if ( ( window.navigator.msPointerEnabled ) || e.touches.length === 1 ) {
                slider.pause();
                // CAROUSEL:
                cwidth = (vertical) ? slider.h : slider. w;
                startT = Number(new Date());
                // CAROUSEL:

                // Local vars for X and Y points.
                localX = e.touches[0].pageX;
                localY = e.touches[0].pageY;

                offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
                         (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                         (carousel && slider.currentSlide === slider.last) ? slider.limit :
                         (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
                         (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                startX = (vertical) ? localY : localX;
                startY = (vertical) ? localX : localY;

                el.addEventListener('touchmove', onTouchMove, false);
                el.addEventListener('touchend', onTouchEnd, false);
              }
            };

            onTouchMove = function(e) {
              // Local vars for X and Y points.

              localX = e.touches[0].pageX;
              localY = e.touches[0].pageY;

              dx = (vertical) ? startX - localY : startX - localX;
              scrolling = (vertical) ? (Math.abs(dx) < Math.abs(localX - startY)) : (Math.abs(dx) < Math.abs(localY - startY));

              var fxms = 500;

              if ( ! scrolling || Number( new Date() ) - startT > fxms ) {
                e.preventDefault();
                if (!fade && slider.transitions) {
                  if (!slider.vars.animationLoop) {
                    dx = dx/((slider.currentSlide === 0 && dx < 0 || slider.currentSlide === slider.last && dx > 0) ? (Math.abs(dx)/cwidth+2) : 1);
                  }
                  slider.setProps(offset + dx, "setTouch");
                }
              }
            };

            onTouchEnd = function(e) {
              // finish the touch by undoing the touch session
              el.removeEventListener('touchmove', onTouchMove, false);

              if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                var updateDx = (reverse) ? -dx : dx,
                    target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');

                if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
                  slider.flexAnimate(target, slider.vars.pauseOnAction);
                } else {
                  if (!fade) { slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true); }
                }
              }
              el.removeEventListener('touchend', onTouchEnd, false);

              startX = null;
              startY = null;
              dx = null;
              offset = null;
            };

            el.addEventListener('touchstart', onTouchStart, false);
        }else{
            el.style.msTouchAction = "none";
            el._gesture = new MSGesture();
            el._gesture.target = el;
            el.addEventListener("MSPointerDown", onMSPointerDown, false);
            el._slider = slider;
            el.addEventListener("MSGestureChange", onMSGestureChange, false);
            el.addEventListener("MSGestureEnd", onMSGestureEnd, false);

            function onMSPointerDown(e){
                e.stopPropagation();
                if (slider.animating) {
                    e.preventDefault();
                }else{
                    slider.pause();
                    el._gesture.addPointer(e.pointerId);
                    accDx = 0;
                    cwidth = (vertical) ? slider.h : slider. w;
                    startT = Number(new Date());
                    // CAROUSEL:

                    offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
                        (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                            (carousel && slider.currentSlide === slider.last) ? slider.limit :
                                (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
                                    (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
                }
            }

            function onMSGestureChange(e) {
                e.stopPropagation();
                var slider = e.target._slider;
                if(!slider){
                    return;
                }
                var transX = -e.translationX,
                    transY = -e.translationY;

                //Accumulate translations.
                accDx = accDx + ((vertical) ? transY : transX);
                dx = accDx;
                scrolling = (vertical) ? (Math.abs(accDx) < Math.abs(-transX)) : (Math.abs(accDx) < Math.abs(-transY));

                if(e.detail === e.MSGESTURE_FLAG_INERTIA){
                    setImmediate(function (){
                        el._gesture.stop();
                    });

                    return;
                }

                if (!scrolling || Number(new Date()) - startT > 500) {
                    e.preventDefault();
                    if (!fade && slider.transitions) {
                        if (!slider.vars.animationLoop) {
                            dx = accDx / ((slider.currentSlide === 0 && accDx < 0 || slider.currentSlide === slider.last && accDx > 0) ? (Math.abs(accDx) / cwidth + 2) : 1);
                        }
                        slider.setProps(offset + dx, "setTouch");
                    }
                }
            }

            function onMSGestureEnd(e) {
                e.stopPropagation();
                var slider = e.target._slider;
                if(!slider){
                    return;
                }
                if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
                    var updateDx = (reverse) ? -dx : dx,
                        target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');

                    if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
                        slider.flexAnimate(target, slider.vars.pauseOnAction);
                    } else {
                        if (!fade) { slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true); }
                    }
                }

                startX = null;
                startY = null;
                dx = null;
                offset = null;
                accDx = 0;
            }
        }
      },
      resize: function() {
        if (!slider.animating && slider.is(':visible')) {
          if (!carousel) { slider.doMath(); }

          if (fade) {
            // SMOOTH HEIGHT:
            methods.smoothHeight();
          } else if (carousel) { //CAROUSEL:
            slider.slides.width(slider.computedW);
            slider.update(slider.pagingCount);
            slider.setProps();
          }
          else if (vertical) { //VERTICAL:
            slider.viewport.height(slider.h);
            slider.setProps(slider.h, "setTotal");
          } else {
            // SMOOTH HEIGHT:
            if (slider.vars.smoothHeight) { methods.smoothHeight(); }
            slider.newSlides.width(slider.computedW);
            slider.setProps(slider.computedW, "setTotal");
          }
        }
      },
      smoothHeight: function(dur) {
        if (!vertical || fade) {
          var $obj = (fade) ? slider : slider.viewport;
          (dur) ? $obj.animate({"height": slider.slides.eq(slider.animatingTo).innerHeight()}, dur) : $obj.innerHeight(slider.slides.eq(slider.animatingTo).innerHeight());
        }
      },
      sync: function(action) {
        var $obj = $(slider.vars.sync).data("flexslider"),
            target = slider.animatingTo;

        switch (action) {
          case "animate": $obj.flexAnimate(target, slider.vars.pauseOnAction, false, true); break;
          case "play": if (!$obj.playing && !$obj.asNav) { $obj.play(); } break;
          case "pause": $obj.pause(); break;
        }
      },
      uniqueID: function($clone) {
        // Append _clone to current level and children elements with id attributes
        $clone.filter( '[id]' ).add($clone.find( '[id]' )).each(function() {
          var $this = $(this);
          $this.attr( 'id', $this.attr( 'id' ) + '_clone' );
        });
        return $clone;
      },
      pauseInvisible: {
        visProp: null,
        init: function() {
          var visProp = methods.pauseInvisible.getHiddenProp();
          if (visProp) {
            var evtname = visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
            document.addEventListener(evtname, function() {
              if (methods.pauseInvisible.isHidden()) {
                if(slider.startTimeout) {
                  clearTimeout(slider.startTimeout); //If clock is ticking, stop timer and prevent from starting while invisible
                } else {
                  slider.pause(); //Or just pause
                }
              }
              else {
                if(slider.started) {
                  slider.play(); //Initiated before, just play
                } else {
                  if (slider.vars.initDelay > 0) {
                    setTimeout(slider.play, slider.vars.initDelay);
                  } else {
                    slider.play(); //Didn't init before: simply init or wait for it
                  }
                }
              }
            });
          }
        },
        isHidden: function() {
          var prop = methods.pauseInvisible.getHiddenProp();
          if (!prop) {
            return false;
          }
          return document[prop];
        },
        getHiddenProp: function() {
          var prefixes = ['webkit','moz','ms','o'];
          // if 'hidden' is natively supported just return it
          if ('hidden' in document) {
            return 'hidden';
          }
          // otherwise loop over all the known prefixes until we find one
          for ( var i = 0; i < prefixes.length; i++ ) {
              if ((prefixes[i] + 'Hidden') in document) {
                return prefixes[i] + 'Hidden';
              }
          }
          // otherwise it's not supported
          return null;
        }
      },
      setToClearWatchedEvent: function() {
        clearTimeout(watchedEventClearTimer);
        watchedEventClearTimer = setTimeout(function() {
          watchedEvent = "";
        }, 3000);
      }
    };

    // public methods
    slider.flexAnimate = function(target, pause, override, withSync, fromNav) {
      if (!slider.vars.animationLoop && target !== slider.currentSlide) {
        slider.direction = (target > slider.currentSlide) ? "next" : "prev";
      }

      if (asNav && slider.pagingCount === 1) slider.direction = (slider.currentItem < target) ? "next" : "prev";

      if (!slider.animating && (slider.canAdvance(target, fromNav) || override) && slider.is(":visible")) {
        if (asNav && withSync) {
          var master = $(slider.vars.asNavFor).data('flexslider');
          slider.atEnd = target === 0 || target === slider.count - 1;
          master.flexAnimate(target, true, false, true, fromNav);
          slider.direction = (slider.currentItem < target) ? "next" : "prev";
          master.direction = slider.direction;

          if (Math.ceil((target + 1)/slider.visible) - 1 !== slider.currentSlide && target !== 0) {
            slider.currentItem = target;
            slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
            target = Math.floor(target/slider.visible);
          } else {
            slider.currentItem = target;
            slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
            return false;
          }
        }

        slider.animating = true;
        slider.animatingTo = target;

        // SLIDESHOW:
        if (pause) { slider.pause(); }

        // API: before() animation Callback
        slider.vars.before(slider);

        // SYNC:
        if (slider.syncExists && !fromNav) { methods.sync("animate"); }

        // CONTROLNAV
        if (slider.vars.controlNav) { methods.controlNav.active(); }

        // !CAROUSEL:
        // CANDIDATE: slide active class (for add/remove slide)
        if (!carousel) { slider.slides.removeClass(namespace + 'active-slide').eq(target).addClass(namespace + 'active-slide'); }

        // INFINITE LOOP:
        // CANDIDATE: atEnd
        slider.atEnd = target === 0 || target === slider.last;

        // DIRECTIONNAV:
        if (slider.vars.directionNav) { methods.directionNav.update(); }

        if (target === slider.last) {
          // API: end() of cycle Callback
          slider.vars.end(slider);
          // SLIDESHOW && !INFINITE LOOP:
          if (!slider.vars.animationLoop) { slider.pause(); }
        }

        // SLIDE:
        if (!fade) {
          var dimension = (vertical) ? slider.slides.filter(':first').height() : slider.computedW,
              margin, slideString, calcNext;

          // INFINITE LOOP / REVERSE:
          if (carousel) {
            margin = slider.vars.itemMargin;
            calcNext = ((slider.itemW + margin) * slider.move) * slider.animatingTo;
            slideString = (calcNext > slider.limit && slider.visible !== 1) ? slider.limit : calcNext;
          } else if (slider.currentSlide === 0 && target === slider.count - 1 && slider.vars.animationLoop && slider.direction !== "next") {
            slideString = (reverse) ? (slider.count + slider.cloneOffset) * dimension : 0;
          } else if (slider.currentSlide === slider.last && target === 0 && slider.vars.animationLoop && slider.direction !== "prev") {
            slideString = (reverse) ? 0 : (slider.count + 1) * dimension;
          } else {
            slideString = (reverse) ? ((slider.count - 1) - target + slider.cloneOffset) * dimension : (target + slider.cloneOffset) * dimension;
          }
          slider.setProps(slideString, "", slider.vars.animationSpeed);
          if (slider.transitions) {
            if (!slider.vars.animationLoop || !slider.atEnd) {
              slider.animating = false;
              slider.currentSlide = slider.animatingTo;
            }

            // Unbind previous transitionEnd events and re-bind new transitionEnd event
            slider.container.unbind("webkitTransitionEnd transitionend");
            slider.container.bind("webkitTransitionEnd transitionend", function() {
              clearTimeout(slider.ensureAnimationEnd);
              slider.wrapup(dimension);
            });

            // Insurance for the ever-so-fickle transitionEnd event
            clearTimeout(slider.ensureAnimationEnd);
            slider.ensureAnimationEnd = setTimeout(function() {
              slider.wrapup(dimension);
            }, slider.vars.animationSpeed + 100);

          } else {
            slider.container.animate(slider.args, slider.vars.animationSpeed, slider.vars.easing, function(){
              slider.wrapup(dimension);
            });
          }
        } else { // FADE:
          if (!touch) {
            slider.slides.eq(slider.currentSlide).css({"zIndex": 1}).animate({"opacity": 0}, slider.vars.animationSpeed, slider.vars.easing);
            slider.slides.eq(target).css({"zIndex": 2}).animate({"opacity": 1}, slider.vars.animationSpeed, slider.vars.easing, slider.wrapup);
          } else {
            slider.slides.eq(slider.currentSlide).css({ "opacity": 0, "zIndex": 1 });
            slider.slides.eq(target).css({ "opacity": 1, "zIndex": 2 });
            slider.wrapup(dimension);
          }
        }
        // SMOOTH HEIGHT:
        if (slider.vars.smoothHeight) { methods.smoothHeight(slider.vars.animationSpeed); }
      }
    };
    slider.wrapup = function(dimension) {
      // SLIDE:
      if (!fade && !carousel) {
        if (slider.currentSlide === 0 && slider.animatingTo === slider.last && slider.vars.animationLoop) {
          slider.setProps(dimension, "jumpEnd");
        } else if (slider.currentSlide === slider.last && slider.animatingTo === 0 && slider.vars.animationLoop) {
          slider.setProps(dimension, "jumpStart");
        }
      }
      slider.animating = false;
      slider.currentSlide = slider.animatingTo;
      // API: after() animation Callback
      slider.vars.after(slider);
    };

    // SLIDESHOW:
    slider.animateSlides = function() {
      if (!slider.animating && focused ) { slider.flexAnimate(slider.getTarget("next")); }
    };
    // SLIDESHOW:
    slider.pause = function() {
      clearInterval(slider.animatedSlides);
      slider.animatedSlides = null;
      slider.playing = false;
      // PAUSEPLAY:
      if (slider.vars.pausePlay) { methods.pausePlay.update("play"); }
      // SYNC:
      if (slider.syncExists) { methods.sync("pause"); }
    };
    // SLIDESHOW:
    slider.play = function() {
      if (slider.playing) { clearInterval(slider.animatedSlides); }
      slider.animatedSlides = slider.animatedSlides || setInterval(slider.animateSlides, slider.vars.slideshowSpeed);
      slider.started = slider.playing = true;
      // PAUSEPLAY:
      if (slider.vars.pausePlay) { methods.pausePlay.update("pause"); }
      // SYNC:
      if (slider.syncExists) { methods.sync("play"); }
    };
    // STOP:
    slider.stop = function () {
      slider.pause();
      slider.stopped = true;
    };
    slider.canAdvance = function(target, fromNav) {
      // ASNAV:
      var last = (asNav) ? slider.pagingCount - 1 : slider.last;
      return (fromNav) ? true :
             (asNav && slider.currentItem === slider.count - 1 && target === 0 && slider.direction === "prev") ? true :
             (asNav && slider.currentItem === 0 && target === slider.pagingCount - 1 && slider.direction !== "next") ? false :
             (target === slider.currentSlide && !asNav) ? false :
             (slider.vars.animationLoop) ? true :
             (slider.atEnd && slider.currentSlide === 0 && target === last && slider.direction !== "next") ? false :
             (slider.atEnd && slider.currentSlide === last && target === 0 && slider.direction === "next") ? false :
             true;
    };
    slider.getTarget = function(dir) {
      slider.direction = dir;
      if (dir === "next") {
        return (slider.currentSlide === slider.last) ? 0 : slider.currentSlide + 1;
      } else {
        return (slider.currentSlide === 0) ? slider.last : slider.currentSlide - 1;
      }
    };

    // SLIDE:
    slider.setProps = function(pos, special, dur) {
      var target = (function() {
        var posCheck = (pos) ? pos : ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo,
            posCalc = (function() {
              if (carousel) {
                return (special === "setTouch") ? pos :
                       (reverse && slider.animatingTo === slider.last) ? 0 :
                       (reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
                       (slider.animatingTo === slider.last) ? slider.limit : posCheck;
              } else {
                switch (special) {
                  case "setTotal": return (reverse) ? ((slider.count - 1) - slider.currentSlide + slider.cloneOffset) * pos : (slider.currentSlide + slider.cloneOffset) * pos;
                  case "setTouch": return (reverse) ? pos : pos;
                  case "jumpEnd": return (reverse) ? pos : slider.count * pos;
                  case "jumpStart": return (reverse) ? slider.count * pos : pos;
                  default: return pos;
                }
              }
            }());

            return (posCalc * -1) + "px";
          }());

      if (slider.transitions) {
        target = (vertical) ? "translate3d(0," + target + ",0)" : "translate3d(" + target + ",0,0)";
        dur = (dur !== undefined) ? (dur/1000) + "s" : "0s";
        slider.container.css("-" + slider.pfx + "-transition-duration", dur);
         slider.container.css("transition-duration", dur);
      }

      slider.args[slider.prop] = target;
      if (slider.transitions || dur === undefined) { slider.container.css(slider.args); }

      slider.container.css('transform',target);
    };

    slider.setup = function(type) {
      // SLIDE:
      if (!fade) {
        var sliderOffset, arr;

        if (type === "init") {
          slider.viewport = $('<div class="' + namespace + 'viewport"></div>').css({"overflow": "hidden", "position": "relative"}).appendTo(slider).append(slider.container);
          // INFINITE LOOP:
          slider.cloneCount = 0;
          slider.cloneOffset = 0;
          // REVERSE:
          if (reverse) {
            arr = $.makeArray(slider.slides).reverse();
            slider.slides = $(arr);
            slider.container.empty().append(slider.slides);
          }
        }
        // INFINITE LOOP && !CAROUSEL:
        if (slider.vars.animationLoop && !carousel) {
          slider.cloneCount = 2;
          slider.cloneOffset = 1;
          // clear out old clones
          if (type !== "init") { slider.container.find('.clone').remove(); }
          slider.container.append(methods.uniqueID(slider.slides.first().clone().addClass('clone')).attr('aria-hidden', 'true'))
                          .prepend(methods.uniqueID(slider.slides.last().clone().addClass('clone')).attr('aria-hidden', 'true'));
        }
        slider.newSlides = $(slider.vars.selector, slider);

        sliderOffset = (reverse) ? slider.count - 1 - slider.currentSlide + slider.cloneOffset : slider.currentSlide + slider.cloneOffset;
        // VERTICAL:
        if (vertical && !carousel) {
          slider.container.height((slider.count + slider.cloneCount) * 200 + "%").css("position", "absolute").width("100%");
          setTimeout(function(){
            slider.newSlides.css({"display": "block"});
            slider.doMath();
            slider.viewport.height(slider.h);
            slider.setProps(sliderOffset * slider.h, "init");
          }, (type === "init") ? 100 : 0);
        } else {
          slider.container.width((slider.count + slider.cloneCount) * 200 + "%");
          slider.setProps(sliderOffset * slider.computedW, "init");
          setTimeout(function(){
            slider.doMath();
            slider.newSlides.css({"width": slider.computedW, "marginRight" : slider.computedM, "float": "left", "display": "block"});
            // SMOOTH HEIGHT:
            if (slider.vars.smoothHeight) { methods.smoothHeight(); }
          }, (type === "init") ? 100 : 0);
        }
      } else { // FADE:
        slider.slides.css({"width": "100%", "float": "left", "marginRight": "-100%", "position": "relative"});
        if (type === "init") {
          if (!touch) {
            //slider.slides.eq(slider.currentSlide).fadeIn(slider.vars.animationSpeed, slider.vars.easing);
            if (slider.vars.fadeFirstSlide == false) {
              slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).css({"opacity": 1});
            } else {
              slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).animate({"opacity": 1},slider.vars.animationSpeed,slider.vars.easing);
            }
          } else {
            slider.slides.css({ "opacity": 0, "display": "block", "webkitTransition": "opacity " + slider.vars.animationSpeed / 1000 + "s ease", "zIndex": 1 }).eq(slider.currentSlide).css({ "opacity": 1, "zIndex": 2});
          }
        }
        // SMOOTH HEIGHT:
        if (slider.vars.smoothHeight) { methods.smoothHeight(); }
      }
      // !CAROUSEL:
      // CANDIDATE: active slide
      if (!carousel) { slider.slides.removeClass(namespace + "active-slide").eq(slider.currentSlide).addClass(namespace + "active-slide"); }

      //FlexSlider: init() Callback
      slider.vars.init(slider);
    };

    slider.doMath = function() {
      var slide = slider.slides.first(),
          slideMargin = slider.vars.itemMargin,
          minItems = slider.vars.minItems,
          maxItems = slider.vars.maxItems;

      slider.w = (slider.viewport===undefined) ? slider.width() : slider.viewport.width();
      slider.h = slide.height();
      slider.boxPadding = slide.outerWidth() - slide.width();

      // CAROUSEL:
      if (carousel) {
        slider.itemT = slider.vars.itemWidth + slideMargin;
        slider.itemM = slideMargin;
        slider.minW = (minItems) ? minItems * slider.itemT : slider.w;
        slider.maxW = (maxItems) ? (maxItems * slider.itemT) - slideMargin : slider.w;
        slider.itemW = (slider.minW > slider.w) ? (slider.w - (slideMargin * (minItems - 1)))/minItems :
                       (slider.maxW < slider.w) ? (slider.w - (slideMargin * (maxItems - 1)))/maxItems :
                       (slider.vars.itemWidth > slider.w) ? slider.w : slider.vars.itemWidth;

        slider.visible = Math.floor(slider.w/(slider.itemW));
        slider.move = (slider.vars.move > 0 && slider.vars.move < slider.visible ) ? slider.vars.move : slider.visible;
        slider.pagingCount = Math.ceil(((slider.count - slider.visible)/slider.move) + 1);
        slider.last =  slider.pagingCount - 1;
        slider.limit = (slider.pagingCount === 1) ? 0 :
                       (slider.vars.itemWidth > slider.w) ? (slider.itemW * (slider.count - 1)) + (slideMargin * (slider.count - 1)) : ((slider.itemW + slideMargin) * slider.count) - slider.w - slideMargin;
      } else {
        slider.itemW = slider.w;
        slider.itemM = slideMargin;
        slider.pagingCount = slider.count;
        slider.last = slider.count - 1;
      }
      slider.computedW = slider.itemW - slider.boxPadding;
      slider.computedM = slider.itemM;
    };

    slider.update = function(pos, action) {
      slider.doMath();

      // update currentSlide and slider.animatingTo if necessary
      if (!carousel) {
        if (pos < slider.currentSlide) {
          slider.currentSlide += 1;
        } else if (pos <= slider.currentSlide && pos !== 0) {
          slider.currentSlide -= 1;
        }
        slider.animatingTo = slider.currentSlide;
      }

      // update controlNav
      if (slider.vars.controlNav && !slider.manualControls) {
        if ((action === "add" && !carousel) || slider.pagingCount > slider.controlNav.length) {
          methods.controlNav.update("add");
        } else if ((action === "remove" && !carousel) || slider.pagingCount < slider.controlNav.length) {
          if (carousel && slider.currentSlide > slider.last) {
            slider.currentSlide -= 1;
            slider.animatingTo -= 1;
          }
          methods.controlNav.update("remove", slider.last);
        }
      }
      // update directionNav
      if (slider.vars.directionNav) { methods.directionNav.update(); }

    };

    slider.addSlide = function(obj, pos) {
      var $obj = $(obj);

      slider.count += 1;
      slider.last = slider.count - 1;

      // append new slide
      if (vertical && reverse) {
        (pos !== undefined) ? slider.slides.eq(slider.count - pos).after($obj) : slider.container.prepend($obj);
      } else {
        (pos !== undefined) ? slider.slides.eq(pos).before($obj) : slider.container.append($obj);
      }

      // update currentSlide, animatingTo, controlNav, and directionNav
      slider.update(pos, "add");

      // update slider.slides
      slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
      // re-setup the slider to accomdate new slide
      slider.setup();

      //FlexSlider: added() Callback
      slider.vars.added(slider);
    };
    slider.removeSlide = function(obj) {
      var pos = (isNaN(obj)) ? slider.slides.index($(obj)) : obj;

      // update count
      slider.count -= 1;
      slider.last = slider.count - 1;

      // remove slide
      if (isNaN(obj)) {
        $(obj, slider.slides).remove();
      } else {
        (vertical && reverse) ? slider.slides.eq(slider.last).remove() : slider.slides.eq(obj).remove();
      }

      // update currentSlide, animatingTo, controlNav, and directionNav
      slider.doMath();
      slider.update(pos, "remove");

      // update slider.slides
      slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
      // re-setup the slider to accomdate new slide
      slider.setup();

      // FlexSlider: removed() Callback
      slider.vars.removed(slider);
    };

    //FlexSlider: Initialize
    methods.init();
  };

  // Ensure the slider isn't focussed if the window loses focus.
  $( window ).blur( function ( e ) {
    focused = false;
  }).focus( function ( e ) {
    focused = true;
  });

  //FlexSlider: Default Settings
  $.flexslider.defaults = {
    namespace: "flex-",             //{NEW} String: Prefix string attached to the class of every element generated by the plugin
    selector: ".slides > li",       //{NEW} Selector: Must match a simple pattern. '{container} > {slide}' -- Ignore pattern at your own peril
    animation: "fade",              //String: Select your animation type, "fade" or "slide"
    easing: "swing",                //{NEW} String: Determines the easing method used in jQuery transitions. jQuery easing plugin is supported!
    direction: "horizontal",        //String: Select the sliding direction, "horizontal" or "vertical"
    reverse: false,                 //{NEW} Boolean: Reverse the animation direction
    animationLoop: true,            //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
    smoothHeight: false,            //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
    startAt: 0,                     //Integer: The slide that the slider should start on. Array notation (0 = first slide)
    slideshow: true,                //Boolean: Animate slider automatically
    slideshowSpeed: 7000,           //Integer: Set the speed of the slideshow cycling, in milliseconds
    animationSpeed: 600,            //Integer: Set the speed of animations, in milliseconds
    initDelay: 0,                   //{NEW} Integer: Set an initialization delay, in milliseconds
    randomize: false,               //Boolean: Randomize slide order
    fadeFirstSlide: true,           //Boolean: Fade in the first slide when animation type is "fade"
    thumbCaptions: false,           //Boolean: Whether or not to put captions on thumbnails when using the "thumbnails" controlNav.

    // Usability features
    pauseOnAction: true,            //Boolean: Pause the slideshow when interacting with control elements, highly recommended.
    pauseOnHover: false,            //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
    pauseInvisible: true,   		//{NEW} Boolean: Pause the slideshow when tab is invisible, resume when visible. Provides better UX, lower CPU usage.
    useCSS: true,                   //{NEW} Boolean: Slider will use CSS3 transitions if available
    touch: true,                    //{NEW} Boolean: Allow touch swipe navigation of the slider on touch-enabled devices
    video: false,                   //{NEW} Boolean: If using video in the slider, will prevent CSS3 3D Transforms to avoid graphical glitches

    // Primary Controls
    controlNav: true,               //Boolean: Create navigation for paging control of each slide? Note: Leave true for manualControls usage
    directionNav: true,             //Boolean: Create navigation for previous/next navigation? (true/false)
    prevText: "Previous",           //String: Set the text for the "previous" directionNav item
    nextText: "Next",               //String: Set the text for the "next" directionNav item

    // Secondary Navigation
    keyboard: true,                 //Boolean: Allow slider navigating via keyboard left/right keys
    multipleKeyboard: false,        //{NEW} Boolean: Allow keyboard navigation to affect multiple sliders. Default behavior cuts out keyboard navigation with more than one slider present.
    mousewheel: false,              //{UPDATED} Boolean: Requires jquery.mousewheel.js (https://github.com/brandonaaron/jquery-mousewheel) - Allows slider navigating via mousewheel
    pausePlay: false,               //Boolean: Create pause/play dynamic element
    pauseText: "Pause",             //String: Set the text for the "pause" pausePlay item
    playText: "Play",               //String: Set the text for the "play" pausePlay item

    // Special properties
    controlsContainer: "",          //{UPDATED} jQuery Object/Selector: Declare which container the navigation elements should be appended too. Default container is the FlexSlider element. Example use would be $(".flexslider-container"). Property is ignored if given element is not found.
    manualControls: "",             //{UPDATED} jQuery Object/Selector: Declare custom control navigation. Examples would be $(".flex-control-nav li") or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
    customDirectionNav: "",         //{NEW} jQuery Object/Selector: Custom prev / next button. Must be two jQuery elements. In order to make the events work they have to have the classes "prev" and "next" (plus namespace)
    sync: "",                       //{NEW} Selector: Mirror the actions performed on this slider with another slider. Use with care.
    asNavFor: "",                   //{NEW} Selector: Internal property exposed for turning the slider into a thumbnail navigation for another slider

    // Carousel Options
    itemWidth: 0,                   //{NEW} Integer: Box-model width of individual carousel items, including horizontal borders and padding.
    itemMargin: 0,                  //{NEW} Integer: Margin between carousel items.
    minItems: 1,                    //{NEW} Integer: Minimum number of carousel items that should be visible. Items will resize fluidly when below this.
    maxItems: 0,                    //{NEW} Integer: Maxmimum number of carousel items that should be visible. Items will resize fluidly when above this limit.
    move: 0,                        //{NEW} Integer: Number of carousel items that should move on animation. If 0, slider will move all visible items.
    allowOneSlide: true,           //{NEW} Boolean: Whether or not to allow a slider comprised of a single slide

    // Callback API
    start: function(){},            //Callback: function(slider) - Fires when the slider loads the first slide
    before: function(){},           //Callback: function(slider) - Fires asynchronously with each slider animation
    after: function(){},            //Callback: function(slider) - Fires after each slider animation completes
    end: function(){},              //Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
    added: function(){},            //{NEW} Callback: function(slider) - Fires after a slide is added
    removed: function(){},           //{NEW} Callback: function(slider) - Fires after a slide is removed
    init: function() {}             //{NEW} Callback: function(slider) - Fires after the slider is initially setup
  };

  //FlexSlider: Plugin Function
  $.fn.flexslider = function(options) {
    if (options === undefined) { options = {}; }

    if (typeof options === "object") {
      return this.each(function() {
        var $this = $(this),
            selector = (options.selector) ? options.selector : ".slides > li",
            $slides = $this.find(selector);

      if ( ( $slides.length === 1 && options.allowOneSlide === false ) || $slides.length === 0 ) {
          $slides.fadeIn(400);
          if (options.start) { options.start($this); }
        } else if ($this.data('flexslider') === undefined) {
          new $.flexslider(this, options);
        }
      });
    } else {
      // Helper strings to quickly perform functions on the slider
      var $slider = $(this).data('flexslider');
      switch (options) {
        case "play": $slider.play(); break;
        case "pause": $slider.pause(); break;
        case "stop": $slider.stop(); break;
        case "next": $slider.flexAnimate($slider.getTarget("next"), true); break;
        case "prev":
        case "previous": $slider.flexAnimate($slider.getTarget("prev"), true); break;
        default: if (typeof options === "number") { $slider.flexAnimate(options, true); }
      }
    }
  };
})(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6), __webpack_require__(413).setImmediate))

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * Lightbox v2.9.0
 * by Lokesh Dhakar
 *
 * More info:
 * http://lokeshdhakar.com/projects/lightbox2/
 *
 * Copyright 2007, 2015 Lokesh Dhakar
 * Released under the MIT license
 * https://github.com/lokesh/lightbox2/blob/master/LICENSE
 *
 * @preserve
 */

// Uses Node, AMD or browser globals to create a module.
(function (root, factory) {
    if (true) {
        // AMD. Register as an anonymous module.
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(6)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals (root is window)
        root.lightbox = factory(root.jQuery);
    }
}(this, function ($) {

  function Lightbox(options) {
    this.album = [];
    this.currentImageIndex = void 0;
    this.init();

    // options
    this.options = $.extend({}, this.constructor.defaults);
    this.option(options);
  }

  // Descriptions of all options available on the demo site:
  // http://lokeshdhakar.com/projects/lightbox2/index.html#options
  Lightbox.defaults = {
    albumLabel: 'Image %1 of %2',
    alwaysShowNavOnTouchDevices: false,
    fadeDuration: 600,
    fitImagesInViewport: true,
    imageFadeDuration: 600,
    // maxWidth: 800,
    // maxHeight: 600,
    positionFromTop: 50,
    resizeDuration: 700,
    showImageNumberLabel: true,
    wrapAround: false,
    disableScrolling: false,
    /*
    Sanitize Title
    If the caption data is trusted, for example you are hardcoding it in, then leave this to false.
    This will free you to add html tags, such as links, in the caption.

    If the caption data is user submitted or from some other untrusted source, then set this to true
    to prevent xss and other injection attacks.
     */
    sanitizeTitle: false
  };

  Lightbox.prototype.option = function(options) {
    $.extend(this.options, options);
  };

  Lightbox.prototype.imageCountLabel = function(currentImageNum, totalImages) {
    return this.options.albumLabel.replace(/%1/g, currentImageNum).replace(/%2/g, totalImages);
  };

  Lightbox.prototype.init = function() {
    var self = this;
    // Both enable and build methods require the body tag to be in the DOM.
    $(document).ready(function() {
      self.enable();
      self.build();
    });
  };

  // Loop through anchors and areamaps looking for either data-lightbox attributes or rel attributes
  // that contain 'lightbox'. When these are clicked, start lightbox.
  Lightbox.prototype.enable = function() {
    var self = this;
    $('body').on('click', 'a[rel^=lightbox], area[rel^=lightbox], a[data-lightbox], area[data-lightbox]', function(event) {
      self.start($(event.currentTarget));
      return false;
    });
  };

  // Build html for the lightbox and the overlay.
  // Attach event handlers to the new DOM elements. click click click
  Lightbox.prototype.build = function() {
    var self = this;
    $('<div id="lightboxOverlay" class="lightboxOverlay"></div><div id="lightbox" class="lightbox"><div class="lb-outerContainer"><div class="lb-container"><img class="lb-image" src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==" /><div class="lb-nav"><a class="lb-prev" href="" ></a><a class="lb-next" href="" ></a></div><div class="lb-loader"><a class="lb-cancel"></a></div></div></div><div class="lb-dataContainer"><div class="lb-data"><div class="lb-details"><span class="lb-caption"></span><span class="lb-number"></span></div><div class="lb-closeContainer"><a class="lb-close"></a></div></div></div></div>').appendTo($('body'));

    // Cache jQuery objects
    this.$lightbox       = $('#lightbox');
    this.$overlay        = $('#lightboxOverlay');
    this.$outerContainer = this.$lightbox.find('.lb-outerContainer');
    this.$container      = this.$lightbox.find('.lb-container');
    this.$image          = this.$lightbox.find('.lb-image');
    this.$nav            = this.$lightbox.find('.lb-nav');

    // Store css values for future lookup
    this.containerPadding = {
      top: parseInt(this.$container.css('padding-top'), 10),
      right: parseInt(this.$container.css('padding-right'), 10),
      bottom: parseInt(this.$container.css('padding-bottom'), 10),
      left: parseInt(this.$container.css('padding-left'), 10)
    };

    this.imageBorderWidth = {
      top: parseInt(this.$image.css('border-top-width'), 10),
      right: parseInt(this.$image.css('border-right-width'), 10),
      bottom: parseInt(this.$image.css('border-bottom-width'), 10),
      left: parseInt(this.$image.css('border-left-width'), 10)
    };

    // Attach event handlers to the newly minted DOM elements
    this.$overlay.hide().on('click', function() {
      self.end();
      return false;
    });

    this.$lightbox.hide().on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$outerContainer.on('click', function(event) {
      if ($(event.target).attr('id') === 'lightbox') {
        self.end();
      }
      return false;
    });

    this.$lightbox.find('.lb-prev').on('click', function() {
      if (self.currentImageIndex === 0) {
        self.changeImage(self.album.length - 1);
      } else {
        self.changeImage(self.currentImageIndex - 1);
      }
      return false;
    });

    this.$lightbox.find('.lb-next').on('click', function() {
      if (self.currentImageIndex === self.album.length - 1) {
        self.changeImage(0);
      } else {
        self.changeImage(self.currentImageIndex + 1);
      }
      return false;
    });

    /*
      Show context menu for image on right-click

      There is a div containing the navigation that spans the entire image and lives above of it. If
      you right-click, you are right clicking this div and not the image. This prevents users from
      saving the image or using other context menu actions with the image.

      To fix this, when we detect the right mouse button is pressed down, but not yet clicked, we
      set pointer-events to none on the nav div. This is so that the upcoming right-click event on
      the next mouseup will bubble down to the image. Once the right-click/contextmenu event occurs
      we set the pointer events back to auto for the nav div so it can capture hover and left-click
      events as usual.
     */
    this.$nav.on('mousedown', function(event) {
      if (event.which === 3) {
        self.$nav.css('pointer-events', 'none');

        self.$lightbox.one('contextmenu', function() {
          setTimeout(function() {
              this.$nav.css('pointer-events', 'auto');
          }.bind(self), 0);
        });
      }
    });


    this.$lightbox.find('.lb-loader, .lb-close').on('click', function() {
      self.end();
      return false;
    });
  };

  // Show overlay and lightbox. If the image is part of a set, add siblings to album array.
  Lightbox.prototype.start = function($link) {
    var self    = this;
    var $window = $(window);

    $window.on('resize', $.proxy(this.sizeOverlay, this));

    $('select, object, embed').css({
      visibility: 'hidden'
    });

    this.sizeOverlay();

    this.album = [];
    var imageNumber = 0;

    function addToAlbum($link) {
      self.album.push({
        link: $link.attr('href'),
        title: $link.attr('data-title') || $link.attr('title')
      });
    }

    // Support both data-lightbox attribute and rel attribute implementations
    var dataLightboxValue = $link.attr('data-lightbox');
    var $links;

    if (dataLightboxValue) {
      $links = $($link.prop('tagName') + '[data-lightbox="' + dataLightboxValue + '"]');
      for (var i = 0; i < $links.length; i = ++i) {
        addToAlbum($($links[i]));
        if ($links[i] === $link[0]) {
          imageNumber = i;
        }
      }
    } else {
      if ($link.attr('rel') === 'lightbox') {
        // If image is not part of a set
        addToAlbum($link);
      } else {
        // If image is part of a set
        $links = $($link.prop('tagName') + '[rel="' + $link.attr('rel') + '"]');
        for (var j = 0; j < $links.length; j = ++j) {
          addToAlbum($($links[j]));
          if ($links[j] === $link[0]) {
            imageNumber = j;
          }
        }
      }
    }

    // Position Lightbox
    var top  = $window.scrollTop() + this.options.positionFromTop;
    var left = $window.scrollLeft();
    this.$lightbox.css({
      top: top + 'px',
      left: left + 'px'
    }).fadeIn(this.options.fadeDuration);

    // Disable scrolling of the page while open
    if (this.options.disableScrolling) {
      $('body').addClass('lb-disable-scrolling');
    }

    this.changeImage(imageNumber);
  };

  // Hide most UI elements in preparation for the animated resizing of the lightbox.
  Lightbox.prototype.changeImage = function(imageNumber) {
    var self = this;

    this.disableKeyboardNav();
    var $image = this.$lightbox.find('.lb-image');

    this.$overlay.fadeIn(this.options.fadeDuration);

    $('.lb-loader').fadeIn('slow');
    this.$lightbox.find('.lb-image, .lb-nav, .lb-prev, .lb-next, .lb-dataContainer, .lb-numbers, .lb-caption').hide();

    this.$outerContainer.addClass('animating');

    // When image to show is preloaded, we send the width and height to sizeContainer()
    var preloader = new Image();
    preloader.onload = function() {
      var $preloader;
      var imageHeight;
      var imageWidth;
      var maxImageHeight;
      var maxImageWidth;
      var windowHeight;
      var windowWidth;

      $image.attr('src', self.album[imageNumber].link);

      $preloader = $(preloader);

      $image.width(preloader.width);
      $image.height(preloader.height);

      if (self.options.fitImagesInViewport) {
        // Fit image inside the viewport.
        // Take into account the border around the image and an additional 10px gutter on each side.

        windowWidth    = $(window).width();
        windowHeight   = $(window).height();
        maxImageWidth  = windowWidth - self.containerPadding.left - self.containerPadding.right - self.imageBorderWidth.left - self.imageBorderWidth.right - 20;
        maxImageHeight = windowHeight - self.containerPadding.top - self.containerPadding.bottom - self.imageBorderWidth.top - self.imageBorderWidth.bottom - 120;

        // Check if image size is larger then maxWidth|maxHeight in settings
        if (self.options.maxWidth && self.options.maxWidth < maxImageWidth) {
          maxImageWidth = self.options.maxWidth;
        }
        if (self.options.maxHeight && self.options.maxHeight < maxImageWidth) {
          maxImageHeight = self.options.maxHeight;
        }

        // Is the current image's width or height is greater than the maxImageWidth or maxImageHeight
        // option than we need to size down while maintaining the aspect ratio.
        if ((preloader.width > maxImageWidth) || (preloader.height > maxImageHeight)) {
          if ((preloader.width / maxImageWidth) > (preloader.height / maxImageHeight)) {
            imageWidth  = maxImageWidth;
            imageHeight = parseInt(preloader.height / (preloader.width / imageWidth), 10);
            $image.width(imageWidth);
            $image.height(imageHeight);
          } else {
            imageHeight = maxImageHeight;
            imageWidth = parseInt(preloader.width / (preloader.height / imageHeight), 10);
            $image.width(imageWidth);
            $image.height(imageHeight);
          }
        }
      }
      self.sizeContainer($image.width(), $image.height());
    };

    preloader.src          = this.album[imageNumber].link;
    this.currentImageIndex = imageNumber;
  };

  // Stretch overlay to fit the viewport
  Lightbox.prototype.sizeOverlay = function() {
    this.$overlay
      .width($(document).width())
      .height($(document).height());
  };

  // Animate the size of the lightbox to fit the image we are showing
  Lightbox.prototype.sizeContainer = function(imageWidth, imageHeight) {
    var self = this;

    var oldWidth  = this.$outerContainer.outerWidth();
    var oldHeight = this.$outerContainer.outerHeight();
    var newWidth  = imageWidth + this.containerPadding.left + this.containerPadding.right + this.imageBorderWidth.left + this.imageBorderWidth.right;
    var newHeight = imageHeight + this.containerPadding.top + this.containerPadding.bottom + this.imageBorderWidth.top + this.imageBorderWidth.bottom;

    function postResize() {
      self.$lightbox.find('.lb-dataContainer').width(newWidth);
      self.$lightbox.find('.lb-prevLink').height(newHeight);
      self.$lightbox.find('.lb-nextLink').height(newHeight);
      self.showImage();
    }

    if (oldWidth !== newWidth || oldHeight !== newHeight) {
      this.$outerContainer.animate({
        width: newWidth,
        height: newHeight
      }, this.options.resizeDuration, 'swing', function() {
        postResize();
      });
    } else {
      postResize();
    }
  };

  // Display the image and its details and begin preload neighboring images.
  Lightbox.prototype.showImage = function() {
    this.$lightbox.find('.lb-loader').stop(true).hide();
    this.$lightbox.find('.lb-image').fadeIn(this.options.imageFadeDuration);

    this.updateNav();
    this.updateDetails();
    this.preloadNeighboringImages();
    this.enableKeyboardNav();
  };

  // Display previous and next navigation if appropriate.
  Lightbox.prototype.updateNav = function() {
    // Check to see if the browser supports touch events. If so, we take the conservative approach
    // and assume that mouse hover events are not supported and always show prev/next navigation
    // arrows in image sets.
    var alwaysShowNav = false;
    try {
      document.createEvent('TouchEvent');
      alwaysShowNav = (this.options.alwaysShowNavOnTouchDevices) ? true : false;
    } catch (e) {}

    this.$lightbox.find('.lb-nav').show();

    if (this.album.length > 1) {
      if (this.options.wrapAround) {
        if (alwaysShowNav) {
          this.$lightbox.find('.lb-prev, .lb-next').css('opacity', '1');
        }
        this.$lightbox.find('.lb-prev, .lb-next').show();
      } else {
        if (this.currentImageIndex > 0) {
          this.$lightbox.find('.lb-prev').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-prev').css('opacity', '1');
          }
        }
        if (this.currentImageIndex < this.album.length - 1) {
          this.$lightbox.find('.lb-next').show();
          if (alwaysShowNav) {
            this.$lightbox.find('.lb-next').css('opacity', '1');
          }
        }
      }
    }
  };

  // Display caption, image number, and closing button.
  Lightbox.prototype.updateDetails = function() {
    var self = this;

    // Enable anchor clicks in the injected caption html.
    // Thanks Nate Wright for the fix. @https://github.com/NateWr
    if (typeof this.album[this.currentImageIndex].title !== 'undefined' &&
      this.album[this.currentImageIndex].title !== '') {
      var $caption = this.$lightbox.find('.lb-caption');
      if (this.options.sanitizeTitle) {
        $caption.text(this.album[this.currentImageIndex].title);
      } else {
        $caption.html(this.album[this.currentImageIndex].title);
      }
      $caption.fadeIn('fast')
        .find('a').on('click', function(event) {
          if ($(this).attr('target') !== undefined) {
            window.open($(this).attr('href'), $(this).attr('target'));
          } else {
            location.href = $(this).attr('href');
          }
        });
    }

    if (this.album.length > 1 && this.options.showImageNumberLabel) {
      var labelText = this.imageCountLabel(this.currentImageIndex + 1, this.album.length);
      this.$lightbox.find('.lb-number').text(labelText).fadeIn('fast');
    } else {
      this.$lightbox.find('.lb-number').hide();
    }

    this.$outerContainer.removeClass('animating');

    this.$lightbox.find('.lb-dataContainer').fadeIn(this.options.resizeDuration, function() {
      return self.sizeOverlay();
    });
  };

  // Preload previous and next images in set.
  Lightbox.prototype.preloadNeighboringImages = function() {
    if (this.album.length > this.currentImageIndex + 1) {
      var preloadNext = new Image();
      preloadNext.src = this.album[this.currentImageIndex + 1].link;
    }
    if (this.currentImageIndex > 0) {
      var preloadPrev = new Image();
      preloadPrev.src = this.album[this.currentImageIndex - 1].link;
    }
  };

  Lightbox.prototype.enableKeyboardNav = function() {
    $(document).on('keyup.keyboard', $.proxy(this.keyboardAction, this));
  };

  Lightbox.prototype.disableKeyboardNav = function() {
    $(document).off('.keyboard');
  };

  Lightbox.prototype.keyboardAction = function(event) {
    var KEYCODE_ESC        = 27;
    var KEYCODE_LEFTARROW  = 37;
    var KEYCODE_RIGHTARROW = 39;

    var keycode = event.keyCode;
    var key     = String.fromCharCode(keycode).toLowerCase();
    if (keycode === KEYCODE_ESC || key.match(/x|o|c/)) {
      this.end();
    } else if (key === 'p' || keycode === KEYCODE_LEFTARROW) {
      if (this.currentImageIndex !== 0) {
        this.changeImage(this.currentImageIndex - 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(this.album.length - 1);
      }
    } else if (key === 'n' || keycode === KEYCODE_RIGHTARROW) {
      if (this.currentImageIndex !== this.album.length - 1) {
        this.changeImage(this.currentImageIndex + 1);
      } else if (this.options.wrapAround && this.album.length > 1) {
        this.changeImage(0);
      }
    }
  };

  // Closing time. :-(
  Lightbox.prototype.end = function() {
    this.disableKeyboardNav();
    $(window).off('resize', this.sizeOverlay);
    this.$lightbox.fadeOut(this.options.fadeDuration);
    this.$overlay.fadeOut(this.options.fadeDuration);
    $('select, object, embed').css({
      visibility: 'visible'
    });
    if (this.options.disableScrolling) {
      $('body').removeClass('lb-disable-scrolling');
    }
  };

  return new Lightbox();
}));

/***/ }),

/***/ 501:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return router; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_404__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__pages_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__pages_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Page__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_Page___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__pages_Page__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Class__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_Class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__pages_Class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_News__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__pages_News___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__pages_News__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_NewsSub__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_NewsSub___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_NewsSub__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Video__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pages_Video___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pages_Video__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_GuestBook__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pages_GuestBook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__pages_GuestBook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_NewGuestBook__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__pages_NewGuestBook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__pages_NewGuestBook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Photo__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pages_Photo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pages_Photo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Site__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pages_Site___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__pages_Site__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_SiteInfo__ = __webpack_require__(1086);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pages_SiteInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__pages_SiteInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Journal__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pages_Journal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__pages_Journal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_JournalContent__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__pages_JournalContent___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__pages_JournalContent__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Team__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pages_Team___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__pages_Team__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Member__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__pages_Member___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__pages_Member__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Administrative__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__pages_Administrative___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__pages_Administrative__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Teacher__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pages_Teacher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__pages_Teacher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_ClassItem__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pages_ClassItem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__pages_ClassItem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_SignUp__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pages_SignUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__pages_SignUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_CoachInfo__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pages_CoachInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__pages_CoachInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Facility__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pages_Facility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__pages_Facility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_ClassInside__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pages_ClassInside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__pages_ClassInside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_TeacherInfo__ = __webpack_require__(1092);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__pages_TeacherInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__pages_TeacherInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_TeacherBasic__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__pages_TeacherBasic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__pages_TeacherBasic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_TeacherBook__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__pages_TeacherBook___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__pages_TeacherBook__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_TeacherEdu__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pages_TeacherEdu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__pages_TeacherEdu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_TeacherJournal__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__pages_TeacherJournal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__pages_TeacherJournal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_TeacherPrize__ = __webpack_require__(1094);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__pages_TeacherPrize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__pages_TeacherPrize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_TeacherResearch__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pages_TeacherResearch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__pages_TeacherResearch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_TeacherSeminar__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__pages_TeacherSeminar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__pages_TeacherSeminar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_TeacherCustom__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pages_TeacherCustom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__pages_TeacherCustom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_PhotoIn__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__pages_PhotoIn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__pages_PhotoIn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_TeamType__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__pages_TeamType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__pages_TeamType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_TeamInfo__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__pages_TeamInfo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__pages_TeamInfo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_breadcrumbs__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_breadcrumbs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vue_breadcrumbs__);













































sessionStorage.locale = sessionStorage.locale || 'CH';

var title = {
  home: { CH: '首頁', EN: 'Home' },
  class: { CH: '運動指導班', EN: 'Class' },
  class_item: { CH: '報名班別', EN: 'Apply Class' },
  class_sign: { CH: '課程報名', EN: 'Class_Sign' },
  coach_info: { CH: '教練簡介', EN: 'Coach_Info' },
  facility: { CH: '場地設施', EN: 'Facility' },
  class_inside: { CH: '上課注意事項', EN: 'Note' },
  news: { CH: '最新消息', EN: 'News' },
  news_sub: { CH: '消息', EN: 'News' },
  video: { CH: '影片', EN: 'Video' },
  guest_book: { CH: '留言板', EN: 'Guest_book' },
  new_guest_book: { CH: '留言板', EN: 'Guest_book' },
  photo: { CH: '相簿', EN: 'Photo' },
  photo_in: { CH: '相簿', EN: 'Photo_In' },
  site: { CH: '場地介紹', EN: 'Site' },
  site_info: { CH: '場地', EN: 'Site_Info' },
  team: { CH: '體育代表隊介紹', EN: 'Team' },
  team_type: { CH: '體育代表隊', EN: 'TeamType' },
  team_info: { CH: '代表隊介紹', EN: 'Team_Info' },
  journal: { CH: '期刊及學報', EN: 'Journal' },
  journal_info: { CH: '內容', EN: 'Journal_Info' },
  member: { CH: '成員介紹', EN: 'member' },
  administrative: { CH: '行政成員介紹', EN: 'AdministrativeMember' },
  teacher: { CH: '師資介紹', EN: 'Teacher' },
  teacher_basic: { CH: '個人資料', EN: 'Teacher_Basic' },
  teacher_book: { CH: '專書及專書論文', EN: 'Teacher_Book' },
  teacher_edu: { CH: '學歷＆課程', EN: 'Teacher_Edu' },
  teacher_journal: { CH: '期刊論文', EN: 'Teacher_Journal' },
  teacher_prize: { CH: '獲獎＆學歷', EN: 'Teacher_Prize' },
  teacher_research: { CH: '專題研究報告及其他', EN: 'Teacher_Research' },
  teacher_seminar: { CH: '研討會論文', EN: 'Teacher_Seminar' },
  teacher_custom: { CH: '師資介紹', EN: 'Teacher_Custom' },
  page: { CH: '其他頁面', EN: 'Page' }
};



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_37_vue_breadcrumbs___default.a);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  routes: [
  // { path: '*', redirect: '/404' },
  {
    path: '/404',
    name: '404',
    meta: { title: 'Page not found' },
    component: __WEBPACK_IMPORTED_MODULE_2__pages_404___default.a
  }, {
    path: '/',
    name: 'home',
    meta: {
      title: '國立臺灣大學體育室',
      keepAlive: true,
      breadcrumb: title.home[sessionStorage.locale]
    },
    component: __WEBPACK_IMPORTED_MODULE_3__pages_Home___default.a,
    children: [{
      path: 'class',
      name: 'class',
      meta: {
        title: title.class[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.class[sessionStorage.locale],
        keepAliveSub: false
      },
      component: __WEBPACK_IMPORTED_MODULE_5__pages_Class___default.a,
      children: [{
        path: ':classid/class_item',
        name: 'class_item',
        meta: {
          title: title.class_item[sessionStorage.locale],
          keepAliveSub: true,
          keepAliveSub2: false,
          breadcrumb: title.class_item[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_20__pages_ClassItem___default.a,
        children: [{
          path: ':classname/:admissionsid/sign_up',
          name: 'class_sign',
          meta: {
            title: title.class_sign[sessionStorage.locale],
            keepAliveSub: true,
            keepAliveSub2: true,
            breadcrumb: title.class_sign[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_21__pages_SignUp___default.a
        }, {
          path: ':classname/coach',
          name: 'coach_info',
          meta: {
            title: title.coach_info[sessionStorage.locale],
            keepAliveSub: true,
            keepAliveSub2: true,
            breadcrumb: title.coach_info[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_22__pages_CoachInfo___default.a
        }, {
          path: ':classname/facility',
          name: 'facility',
          meta: {
            title: title.facility[sessionStorage.locale],
            keepAliveSub: true,
            keepAliveSub2: true,
            breadcrumb: title.facility[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_23__pages_Facility___default.a
        }, {
          path: ':classname/note',
          name: 'class_inside',
          meta: {
            title: title.class_inside[sessionStorage.locale],
            keepAliveSub: true,
            keepAliveSub2: true,
            breadcrumb: title.class_inside[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_24__pages_ClassInside___default.a
        }]
      }]
    }, {
      path: 'news',
      name: 'news',
      meta: {
        title: title.news[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.news[sessionStorage.locale],
        keepAliveSub: false
      },
      component: __WEBPACK_IMPORTED_MODULE_6__pages_News___default.a,
      children: [{
        path: ':newsid/news',
        name: 'news_sub',
        meta: {
          title: title.news_sub[sessionStorage.locale],
          keepAliveSub: true,
          breadcrumb: title.news_sub[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_7__pages_NewsSub___default.a
      }]
    }, {
      path: 'video',
      name: 'video',
      meta: {
        title: title.video[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.video[sessionStorage.locale],
        keepAliveSub: false
      },
      component: __WEBPACK_IMPORTED_MODULE_8__pages_Video___default.a
    }, {
      path: 'guest_book',
      name: 'guest_book',
      meta: {
        title: title.guest_book[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.guest_book[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_9__pages_GuestBook___default.a
    }, {
      path: 'new_guest_book',
      name: 'new_guest_book',
      meta: {
        title: title.new_guest_book[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.new_guest_book[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_10__pages_NewGuestBook___default.a
    }, {
      path: 'photo',
      name: 'photo',
      meta: {
        title: title.photo[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.photo[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_11__pages_Photo___default.a,
      children: [{
        path: ':albumId/photo_in',
        name: 'photo_in',
        meta: {
          title: title.photo_in[sessionStorage.locale],
          keepAliveSub: true
        },
        component: __WEBPACK_IMPORTED_MODULE_34__pages_PhotoIn___default.a
      }]
    }, {
      path: 'site',
      name: 'site',
      meta: {
        title: title.site[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.site[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_12__pages_Site___default.a,
      children: [{
        path: ':site/site_info',
        name: 'site_info',
        meta: {
          title: title.site_info[sessionStorage.locale],
          keepAliveSub: true,
          breadcrumb: title.site_info[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_13__pages_SiteInfo___default.a
      }]
    }, {
      path: 'team',
      name: 'team',
      meta: {
        title: title.team[sessionStorage.locale],
        keepAliveSub: true,
        breadcrumb: title.team[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_16__pages_Team___default.a,
      children: [{
        path: ':teamtypeid/team_type',
        name: 'team_type',
        meta: {
          title: title.team_type[sessionStorage.locale],
          keepAliveSub2: true,
          breadcrumb: title.team_type[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_35__pages_TeamType___default.a,
        children: [{
          path: ':teamid/team_info',
          name: 'team_info',
          meta: {
            title: title.team_info[sessionStorage.locale],
            keepAliveSub3: true,
            breadcrumb: title.team_info[sessionStorage.locale]
          },
          component: __WEBPACK_IMPORTED_MODULE_36__pages_TeamInfo___default.a
        }]
      }]
    }, {
      path: 'journal',
      name: 'journal',
      meta: {
        title: title.journal[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.journal[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_14__pages_Journal___default.a,
      children: [{
        path: ':journalid/content',
        name: 'journal_info',
        meta: {
          title: title.journal_info[sessionStorage.locale],
          keepAliveSub: true,
          breadcrumb: title.journal_info[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_15__pages_JournalContent___default.a
      }]
    }, {
      path: 'member',
      name: '',
      meta: {
        title: title.member[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.member[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_17__pages_Member___default.a,
      children: [{
        path: 'administrative',
        name: 'administrative',
        meta: {
          title: title.administrative[sessionStorage.locale],
          keepAlive: false,
          breadcrumb: title.administrative[sessionStorage.locale]
        },
        component: __WEBPACK_IMPORTED_MODULE_18__pages_Administrative___default.a
      }, {
        path: 'teacher',
        name: 'teacher',
        meta: {
          title: title.teacher[sessionStorage.locale],
          keepAlive: false,
          breadcrumb: title.teacher[sessionStorage.locale],
          keepAliveSub: false
        },
        component: __WEBPACK_IMPORTED_MODULE_19__pages_Teacher___default.a,
        children: [{
          path: ':teacherid/',
          name: 'teacher_info',
          meta: {
            title: 'xxx',
            keepAliveSub: true
          },
          component: __WEBPACK_IMPORTED_MODULE_25__pages_TeacherInfo___default.a,
          children: [{
            path: 'basic',
            name: 'teacher_basic',
            meta: {
              title: title.teacher_basic[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_basic[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_26__pages_TeacherBasic___default.a
          }, {
            path: 'book',
            name: 'teacher_book',
            meta: {
              title: title.teacher_book[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_book[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_27__pages_TeacherBook___default.a
          }, {
            path: 'edu',
            name: 'teacher_edu',
            meta: {
              title: title.teacher_edu[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_edu[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_28__pages_TeacherEdu___default.a
          }, {
            path: 'journal',
            name: 'teacher_journal',
            meta: {
              title: title.teacher_journal[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_journal[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_29__pages_TeacherJournal___default.a
          }, {
            path: 'prize',
            name: 'teacher_prize',
            meta: {
              title: title.teacher_prize[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_prize[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_30__pages_TeacherPrize___default.a
          }, {
            path: 'research',
            name: 'teacher_research',
            meta: {
              title: title.teacher_research[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_research[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_31__pages_TeacherResearch___default.a
          }, {
            path: 'seminar',
            name: 'teacher_seminar',
            meta: {
              title: title.teacher_seminar[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_seminar[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_32__pages_TeacherSeminar___default.a
          }, {
            path: ':custom',
            name: 'teacher_custom',
            meta: {
              title: title.teacher_custom[sessionStorage.locale],
              keepAliveSub: true,
              breadcrumb: title.teacher_custom[sessionStorage.locale]
            },
            component: __WEBPACK_IMPORTED_MODULE_33__pages_TeacherCustom___default.a
          }]
        }]
      }]
    }, {
      path: ':pageName',
      name: 'page',
      meta: {
        title: title.page[sessionStorage.locale],
        keepAlive: false,
        breadcrumb: title.page[sessionStorage.locale]
      },
      component: __WEBPACK_IMPORTED_MODULE_4__pages_Page___default.a
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  document.title = to.meta.title;
  next();
});

/***/ }),

/***/ 505:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(914)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(526),
  /* template */
  __webpack_require__(1222),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 529:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'administrative',
  data: function data() {
    return {
      admins: [],
      currentPage: 1,
      pagesize: 10,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initAdmins();
    },
    initAdmins: function initAdmins() {
      this.getAdminsData();
    },
    getAdminsData: function getAdminsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].admin).then(function (response) {
        _this.admins = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    showJobTitle: function showJobTitle(admin) {
      var jobTitle = { 'CH': admin.jobTitleCh, 'EN': admin.jobTitleEn };
      return jobTitle[sessionStorage.locale];
    },
    showGroup: function showGroup(admin) {
      var group = {
        'CH': ['無', '體育教學組', '體育活動組', '場地設備組', '法醫校區體育組', '主任室'],
        'EN': ['none', 'Curriculum Section', 'Activities Section', 'Site Section', 'Forensic Section', 'Director Office']
      };
      return group[sessionStorage.locale][admin.activityGroup];
    },
    showName: function showName(admin) {
      var name = { 'CH': admin.nameCh, 'EN': admin.nameEn };
      return name[sessionStorage.locale];
    },
    showIntroduction: function showIntroduction(admin) {
      var introduction = { 'CH': admin.introductionCh, 'EN': admin.introductionEn };
      return introduction[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 530:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'class',
  data: function data() {
    return {

      classes: [],
      nowClassitem: '',
      course: '',
      locale: sessionStorage.getItem('locale')
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initCourse();
      this.initClasses();
    },
    initClasses: function initClasses() {
      this.getClassesData();
    },
    initCourse: function initCourse() {
      this.getCourseData();
    },
    getClassesData: function getClassesData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].class + '?courseid=1').then(function (response) {
        _this.classes = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    initCourses: function initCourses() {
      this.getCoursesData();
    },
    initClass: function initClass(classitem) {
      this.nowClassitem = classitem;
    },
    getCourseData: function getCourseData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].course + '?id=1').then(function (response) {
        _this2.course = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    selectClass: function selectClass(classitem) {
      this.nowClassitem = classitem;
      this.$router.push({ name: 'class_item', params: { classid: classitem.id } });
    },
    showName: function showName(classitem) {
      return sessionStorage.locale === 'CH' ? classitem.nameCh : classitem.nameEn;
    },
    showIntroduction: function showIntroduction() {
      return sessionStorage.locale === 'CH' ? this.course.introductionCh : this.course.introductionEn;
    },
    showApplication: function showApplication() {
      return sessionStorage.locale === 'CH' ? this.course.applicationCh : this.course.applicationEn;
    }
  }
});

/***/ }),

/***/ 531:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'class_inside',
  props: ['classitem'],
  data: function data() {
    return {
      className: this.$route.params.classname,
      locale: sessionStorage.getItem('locale'),
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    showNote: function showNote() {
      return sessionStorage.locale === 'CH' ? this.classitem.noteCh : this.classitem.noteEn;
    }
  }
});

/***/ }),

/***/ 532:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'class_item',
  props: ['classitem'],
  data: function data() {
    return {
      classId: this.$route.params.classid,
      admissions: [],
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')),
      className: ''
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initAdmissions();
      this.initParentClass();
    },
    initParentClass: function initParentClass() {
      if (!this.classitem) {
        this.getClassData();
      }
    },
    initAdmissions: function initAdmissions() {
      this.getAdmissionsData();
    },
    getClassData: function getClassData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].class + ('?id=' + this.classId)).then(function (response) {
        _this.$emit('initClass', response.data);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getAdmissionsData: function getAdmissionsData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].classadmissions + ('?classId=' + this.classId)).then(function (response) {
        _this2.admissions = response.data;
        _this2.handleReceivedAdmissions();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    handleReceivedAdmissions: function handleReceivedAdmissions() {
      this.admissions.forEach(function (admission) {
        try {
          admission.memberType = JSON.parse(admission.memberType);
          admission.memberType = admission.memberType.map(function (el) {
            if (sessionStorage.locale === 'CH') return el == 1 ? '成人' : '兒童';else return el == 1 ? 'Adult' : 'Child';
          }).toString().replace(',', '/');
        } catch (error) {}
      }, this);
    },
    signUp: function signUp(id) {
      this.$router.push({ name: 'class_sign', params: { classname: this.showName(), admissionsid: id } });
    },
    classTypeName: function classTypeName(admission) {
      if (sessionStorage.locale === 'CH') {
        var level = ['', '初階', '進階', '矯正'],
            maxPersonal = ['零', '一', '二', '三', '四', '五'];
        if (admission.type === 1) {
          return admission.maxPersonal + level[admission.classLevel] + '班';
        } else if (admission.type === 2) {
          return '團體' + level[admission.classLevel] + '班';
        }
      } else {
        var _level = ['', 'Beginner', 'Advanced', 'Correction'],
            _maxPersonal = ['zero', 'one', 'two', 'three', 'four', 'five'];
        if (admission.type === 1) {
          return admission.maxPersonal + ' ' + _level[admission.classLevel] + ' class';
        } else if (admission.type === 2) {
          return 'Group ' + _level[admission.classLevel] + ' Class';
        }
      }
    },
    showName: function showName() {
      return sessionStorage.locale === 'CH' ? this.classitem.nameCh : this.classitem.nameEn;
    },
    showIntroduction: function showIntroduction() {
      return sessionStorage.locale === 'CH' ? this.classitem.introductionCh : this.classitem.introductionEn;
    },
    showNote: function showNote() {
      return sessionStorage.locale === 'CH' ? this.classitem.noteCh : this.classitem.noteEn;
    },
    memberRange: function memberRange(admission) {
      if (admission.minMember == admission.maxMember) {
        return admission.maxMember;
      } else {
        return admission.minMember + '~' + admission.maxMember;
      }
    }
  }
});

/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'coach_info',
  data: function data() {
    return {
      classId: this.$route.params.classid,
      coachs: [],
      className: this.$route.params.classname,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initCoachs();
    },
    initCoachs: function initCoachs() {
      this.getCoachsData();
    },
    getCoachsData: function getCoachsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].classcoach + ('?classid=' + this.classId)).then(function (response) {
        _this.coachs = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    showName: function showName(coach) {
      return sessionStorage.locale === 'CH' ? coach.nameCh : coach.nameEn;
    },
    showSex: function showSex(sex) {
      return sessionStorage.locale === 'CH' ? sex ? '男' : '女' : sex ? 'male' : 'Female';
    },
    showLicense: function showLicense(coach) {
      return sessionStorage.locale === 'CH' ? coach.licenseCh : coach.licenseEn;
    },
    showHistory: function showHistory(coach) {
      return sessionStorage.locale === 'CH' ? coach.historyCh : coach.historyEn;
    }
  }
});

/***/ }),

/***/ 534:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'facility',
  props: ['classitem'],
  data: function data() {
    return {
      className: this.$route.params.classname,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    showSite: function showSite() {
      return sessionStorage.locale === 'CH' ? this.classitem.siteCh : this.classitem.siteEn;
    }
  }
});

/***/ }),

/***/ 535:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'guest_book',
  data: function data() {
    return {
      spinShow: true,
      books: [],
      currentPage: 1,
      pagesize: 10,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    changeBreak: function changeBreak(str) {
      var index = 0;
      var index2 = 0;
      while (str.indexOf("\n", index) != -1) {
        str = str.replace("\n", "<br />");
        index = str.indexOf("\n", index);
      }
      while (str.indexOf("&#10;", index2) != -1) {
        str = str.replace("&#10;", "<br />");
        index2 = str.indexOf("&#10;", index2);
      }

      return str;
    },
    init: function init() {
      this.initBooks();
    },
    initBooks: function initBooks() {
      this.getBooksData();
    },
    getBooksData: function getBooksData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].message).then(function (response) {
        //for (var i = response.data.length - 1; i >= 0; i--) {
        //  this.books.push(response.data[i])
        //}
        _this.books = response.data;
        _this.books = _this.books.filter(function (data) {
          return data.trash !== 1 && data.isDisplay === 1;
        });
      }).then(function () {
        _this.spinShow = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    }
  }
});

/***/ }),

/***/ 536:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_tabs_js__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__static_js_home_js__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_HomeNotice_vue__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pages_HomeNotice_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__pages_HomeNotice_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// 原 jquery-latest.min.js（實為 jQuery 1.11.1，含 CVE-2020-11022）已移除，
// 其檔尾附加的頁籤切換邏輯抽出為 tabs.js，行為不變








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  components: {
    HomeNotice: __WEBPACK_IMPORTED_MODULE_7__pages_HomeNotice_vue___default.a
  },
  data: function data() {
    return {
      notices: [
        // {
        //  createdAt: '',
        //  title: '',
        //  typeId: '',
        // keepTop: '',
        // }
      ],
      types: [{
        id: 0,
        nameCh: '最新消息',
        nameEn: 'latest news',
        homeDisplay: 1
      }],
      type: { id: 0 },
      noticepictures: [],
      videos: [],
      video: '',
      menu: [],
      course: {},
      classes: [],
      alert: [],
      modal: false,
      nowRocYear: '',
      links: [],
      locale: sessionStorage.getItem('locale'),
      news: { CH: '最新消息', EN: 'latest news' },
      academicYear: { CH: '學年度', EN: ' Academic Year ' },
      homeTitle: { CH: '臺灣大學體育室', EN: 'Department of Athletics, NTU' },
      footTitle: { CH: '國立臺灣大學體育室', EN: 'National Taiwan University Gymnasium' },

      footContent1: { CH: '地址：臺北市羅斯福路四段一號', EN: 'Address: No. 1, Sec. 4, Roosevelt Road, Taipei, 10617 Taiwan(R.O.C)' },
      footContent2: {
        CH: '信箱：ntupe@ntu.edu.tw',
        EN: 'Mail：ntupe@ntu.edu.tw'
      },

      homeInfoCh: "",
      homeInfoEn: "",
      nowYear: ''

    };
  },
  created: function created() {
    if (!sessionStorage.locale) {
      sessionStorage.setItem('locale', 'CH');
      this.locale = 'CH';
    }
    this.nowYear = new Date().getFullYear();
    this.init();
  },


  mounted: function mounted() {
    this.$nextTick(function () {
      __WEBPACK_IMPORTED_MODULE_2__assets_library_tabs_js__["a" /* default */].init();
    });
  },
  updated: function updated() {
    __WEBPACK_IMPORTED_MODULE_2__assets_library_tabs_js__["a" /* default */].init();
    __WEBPACK_IMPORTED_MODULE_3__static_js_home_js__["a" /* default */].init();
    __WEBPACK_IMPORTED_MODULE_3__static_js_home_js__["a" /* default */].test();
  },

  methods: {
    init: function init() {
      this.showPage();
      this.initNowRocYear();
      this.initNotice();
      this.initTypes();
      this.initVideo();
      this.initMenu();
      this.initCourse();

      this.initLinks();
      this.getAlert();
    },
    initNowRocYear: function initNowRocYear() {
      var now = new Date();
      this.nowRocYear = now.getFullYear() - 1910;
    },
    initTypes: function initTypes() {
      this.getTypesData();
    },
    initNotice: function initNotice() {
      this.getNoticeData();
    },
    initVideo: function initVideo() {
      this.getVideoData();
    },
    initMenu: function initMenu() {
      this.getMenuData();
    },
    initCourse: function initCourse() {
      this.getCourseData();
    },
    initClasses: function initClasses() {
      this.getClassesData();
    },
    initLinks: function initLinks() {
      this.getlinksData();
    },
    getAlert: function getAlert() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].setting + "?id=1").then(function (response) {
        _this.alert = response.data;
        _this.homeInfoCh = response.data.homeInfoCh;
        _this.homeInfoEn = response.data.homeInfoEn;
      }).then(function () {
        if (_this.alert && _this.alert.isActive == 1) {
          alert(_this.alert.context);
          // this.modal = true
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getNoticeData: function getNoticeData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].notice + "?groupTop=8").then(function (response) {
        _this2.notices = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this2.handleReceivedNotices();
        _this2.getNoticePictures();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    getTypesData: function getTypesData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].code + "?type=2").then(function (response) {
        _this3.types = _this3.types.concat(response.data.filter(function (data) {
          return data.trash !== 1 && data.homeDisplay === 1;
        }));
        // this.type = this.types.filter(type => {
        //   return type.homeDisplay === 1;
        // })[0];
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this3)(error);
      });
    },
    getVideoData: function getVideoData() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].video).then(function (response) {
        _this4.videos = response.data;
        while (1) {
          var random = Math.floor(Math.random() * _this4.videos.length);
          if (_this4.videos[random].fileUrl) {
            _this4.video = _this4.videos[random];
            break;
          }
        }
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this4)(error);
      });
    },
    getMenuData: function getMenuData() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].menu + '/tree').then(function (response) {
        _this5.menu = response.data.baseData;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this5)(error);
      });
    },
    getNoticePictures: function getNoticePictures() {
      var _this6 = this;

      this.notices.forEach(function (notice) {
        if (notice.pictures) {
          notice.pictures.forEach(function (picture) {
            if (!picture.file_url) return;
            var newnotice = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, notice);
            newnotice.pictures = picture.file_url;
            _this6.noticepictures.push(newnotice);
          }, _this6);
        }
      }, this);
    },
    getCourseData: function getCourseData() {
      var _this7 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].course)
      // axios.get(API.course + '?id=1')
      .then(function (response) {
        var course = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this7.course = course[course.length - 1];
      }).then(function () {
        _this7.initClasses();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this7)(error);
      });
    },
    getClassesData: function getClassesData() {
      var _this8 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].class + ("?courseid=" + this.course.id)).then(function (response) {
        _this8.classes = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this8)(error);
      });
    },
    getlinksData: function getlinksData() {
      var _this9 = this;

      __WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_5__assets_project_setting_config__["b" /* API */].link).then(function (response) {
        _this9.links = response.data.filter(function (data) {
          return data.trash !== 1 && data.isActive === 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this9)(error);
      });
    },
    handleReceivedNotices: function handleReceivedNotices() {
      this.notices.sort(function (a, b) {
        var ac = a.createdAt.split(' '),
            acd = ac[0].split('-'),
            act = ac[1].split(':'),
            bc = b.createdAt.split(' '),
            bcd = bc[0].split('-'),
            bct = bc[1].split(':');
        var aDate = new Date(acd[0], acd[1] - 1, acd[2], act[0], act[1], act[2]),
            bDate = new Date(bcd[0], bcd[1] - 1, bcd[2], bct[0], bct[1], bct[2]);

        if (aDate.getTime() < bDate.getTime()) return 1;
        return -1;
      });
    },
    pushToClassItem: function pushToClassItem(id) {
      this.$router.push({ name: 'class_item', params: { classid: id } });
    },
    selectType: function selectType(type) {
      this.type = type;
    },
    subMenu: function subMenu(data) {
      if (data.target.attributes.var) {
        $(".sub[var=\"" + data.target.attributes.var.value + "\"]").slideToggle();
      } else {
        $('.sub').slideUp();
      }
    },
    pushToNewsSub: function pushToNewsSub(newsitem) {
      if (newsitem.linkType !== 1) return;
      this.newsitem = newsitem;
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target: function target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href: function href(newsitem) {
      if (newsitem.linkType === 2 && newsitem.externalLink) return newsitem.externalLink;
      return undefined;
    },
    setLocale: function setLocale(lanuage) {
      sessionStorage.setItem('locale', lanuage);
      if (this.$route.name === 'coach_info' || this.$route.name === 'facility' || this.$route.name === 'class_inside') this.$router.push({ name: 'class_item', params: { classid: this.$route.params.classid } });
      window.location.reload();
    },
    showPage: function showPage() {
      this.academicYear = this.academicYear[this.locale];
      this.homeTitle = this.homeTitle[this.locale];
      this.footTitle = this.footTitle[this.locale];
      this.footContent1 = this.footContent1[this.locale];
      this.footContent2 = this.footContent2[this.locale];
      this.news = this.news[this.locale];
    },
    showTitle: function showTitle(itemone) {
      return sessionStorage.locale === 'CH' ? itemone.titleCh : itemone.titleEn;
    },
    showType: function showType(type) {
      return sessionStorage.locale === 'CH' ? type.nameCh : type.nameEn;
    },
    showCourseName: function showCourseName() {
      var show = { CH: this.course.nameCh, EN: this.course.nameEn };
      return show[sessionStorage.locale];
    },
    checkTitle: function checkTitle(itemone) {
      var show = { CH: itemone.titleCh, EN: itemone.titleEn };
      return show[sessionStorage.locale] ? true : false;
    },
    linkUrl: function linkUrl(item) {
      if (item.linkUrl.includes('http')) {
        if (item.openMode == 2) {
          window.open(item.linkUrl, '_blank');
        } else {
          location.href = item.linkUrl;
        }
      } else {
        location.href = '#/' + item.linkUrl;
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'tab_container',
  props: ['type', 'notices'],
  data: function data() {
    return {
      newsitem: '',
      locale: sessionStorage.getItem('locale')
    };
  },

  computed: {
    topNotice: function topNotice() {
      var _this = this;

      var arr = this.notices;
      arr = arr.filter(function (item) {
        return (item.typeId == _this.type.id || _this.type.id === 0) && item.isTop && item.language.toUpperCase() === _this.locale;
      });
      return arr;
    },
    normalNotices: function normalNotices() {
      var _this2 = this;

      var arr = this.notices;
      // 1. 第一階段：篩選內容 (維持原本邏輯：類別、非置頂、語言)
      arr = arr.filter(function (item) {
        return (item.typeId == _this2.type.id || _this2.type.id === 0) && !item.isTop && item.language.toUpperCase() === _this2.locale;
      });
      // 2. 第二階段：數量截斷 (總數維持 5 筆)
      // 計算邏輯：目標 5 筆 - 目前置頂的數量
      var limit = 5 - this.topNotice.length;
      return arr.slice(0, Math.max(0, limit));
    }
  },
  methods: {
    pushToNews: function pushToNews(newsitem) {
      this.$router.push({ name: 'news' });
    },
    pushToNewsSub: function pushToNewsSub(newsitem) {
      if (newsitem.linkType !== 1) return;
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target: function target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href: function href(newsitem) {
      if (newsitem.linkType === 2 && newsitem.externalLink) return newsitem.externalLink;
      return undefined;
    }
  }
});

/***/ }),

/***/ 538:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'journal',
  data: function data() {
    return {
      types: [],
      nowType: '',
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initType();
    },
    initType: function initType() {
      this.getTypeData();
    },
    initNowType: function initNowType() {
      var _this = this;

      if (this.$route.params.journalid) {
        this.types.some(function (type) {
          if (type.id = _this.$route.params.journalid) {
            _this.nowType = type;
            return true;
          }
        });
      }
    },
    getTypeData: function getTypeData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].code + '?type=1').then(function (response) {
        _this2.types = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this2.initNowType();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    pushToJournal: function pushToJournal(typeobj) {
      this.nowType = typeobj;
      this.$router.push({ name: 'journal_info', params: { journalid: typeobj.id } });
    },
    showName: function showName(typeobj) {
      var show = { 'CH': typeobj.nameCh, 'EN': typeobj.nameEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'journal_content',
  props: ['type'],
  data: function data() {
    return {
      journalId: this.$route.params.journalid,
      journals: [],
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initJournals();
      this.initType();
    },
    initJournals: function initJournals() {
      this.getData();
    },
    initType: function initType() {
      // this.$emit
    },
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].journal + ('?typeId=' + this.journalId)).then(function (response) {
        _this.journals = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this.sort();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    sort: function sort() {
      this.journals.sort(function (a, b) {
        var aDate = new Date(a.createdAt),
            bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime()) return 1;
        return -1;
      });
    },
    showName: function showName(type) {
      var show = { 'CH': type.nameCh, 'EN': type.nameEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'member',
  data: function data() {
    return {};
  },

  methods: {}
});

/***/ }),

/***/ 542:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__ = __webpack_require__(243);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'new_guest_book',
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_3_vue_recaptcha__["a" /* default */] },
  data: function data() {
    return {
      book: {
        guestName: '',
        guestEmail: '',
        guestMessage: '',
        verifycode: ''
      },
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },


  methods: {
    onSubmit: function onSubmit() {
      this.$refs.invisibleRecaptcha.execute();
    },
    onVerify: function onVerify(response) {
      this.verifycode = response;
    },

    sendMessage: function sendMessage() {
      var _this = this;

      try {
        this.checkName();
        this.checkEmail();
        this.verify();
      } catch (error) {
        alert(error.message);
        return;
      }

      var form = new FormData();

      form.append('guestName', this.book.guestName || '');
      form.append('guestEmail', this.book.guestEmail || '');
      form.append('guestMessage', this.book.guestMessage || '');
      form.append('g-recaptcha-response', this.verifycode);

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].message, form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
        _this.$Message.destroy();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["b" /* ShowMessage */])(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["c" /* Message */].SaveSuccessfully[sessionStorage.locale]);
        _this.$router.push({ name: 'guest_book' });
      }).catch(function (error) {
        _this.$Message.destroy();
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["c" /* PostErrorHandler */].bind(_this)(error, 'message');
      });
    },
    checkName: function checkName() {
      if (!this.book.guestName) {
        throw new Error('請輸入姓名');
      }
    },
    verify: function verify() {
      if (!this.verifycode) {
        throw new Error('請勾選驗證');
      }
    },
    checkEmail: function checkEmail() {
      var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (this.book.guestEmail && !this.book.guestEmail.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    }
  }
});

/***/ }),

/***/ 543:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news',
  data: function data() {
    return {
      spinShow: true,
      allNews: [],
      news: [],
      hotNews: [],
      normalNews: [],
      newsitem: '',
      types: [],
      currentPage: 1,
      pagesize: 10,
      on: { 1: { on: true } },
      locale: sessionStorage.getItem('locale'),
      newsTitle: { CH: '最新消息', EN: 'Latest News' },
      allNewsExec: false,
      typesExec: false
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.showPage();
      this.initNews();
      this.initTypes();
    },
    initNews: function initNews() {
      this.getNewsData();
    },
    initTypes: function initTypes() {
      this.getTypesData();
    },
    initNewsitem: function initNewsitem(newsitem) {
      this.newsitem = newsitem;
    },
    getNewsData: function getNewsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].notice).then(function (response) {
        _this.allNews = response.data.filter(function (data) {
          return data.trash !== 1 && data.language.toUpperCase() === _this.locale;
        });
        // this.handleReceivedNews();
        _this.allNewsExec = true;
        if (_this.allNewsExec && _this.typesData) _this.selectName(_this.types[0].id);
      }).then(function () {
        _this.spinShow = false;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getHotNewsData: function getHotNewsData() {
      this.hotNews = this.news.filter(function (news) {
        return news.isTop;
      });
    },
    getNormalNewsData: function getNormalNewsData() {
      this.normalNews = this.news.filter(function (news) {
        return !news.isTop;
      });
    },
    getTypesData: function getTypesData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].code + '?type=2').then(function (response) {
        _this2.types = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this2.typesData = true;
        if (_this2.allNewsExec && _this2.typesData) _this2.selectName(_this2.types[0].id);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    handleReceivedNews: function handleReceivedNews() {
      this.allNews.sort(function (a, b) {
        var aDate = new Date(a.createdAt),
            bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime()) return 1;
        return -1;
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    focus: function focus(index) {
      this.on = {};
      this.on[index] = { on: true };
    },
    selectName: function selectName(id) {
      this.currentPage = 1;
      this.news = this.allNews.filter(function (news) {
        return news.typeId == id;
      });
      this.getHotNewsData();
      this.getNormalNewsData();
    },
    pushToNew: function pushToNew() {
      if (this.$route.name === 'news_sub') this.$router.push({ name: 'news' });
    },
    pushToNewsSub: function pushToNewsSub(newsitem) {
      if (newsitem.linkType !== 1) return;
      this.newsitem = newsitem;
      this.$router.push({ name: 'news_sub', params: { newsid: newsitem.id } });
    },
    target: function target(newsitem) {
      return newsitem.linkType === 2 && newsitem.openMode === 2;
    },
    href: function href(newsitem) {
      if (newsitem.linkType === 2 && newsitem.externalLink) return newsitem.externalLink;
      return undefined;
    },
    showPage: function showPage() {
      this.newsTitle = this.newsTitle[this.locale];
    },
    showType: function showType(type) {
      return sessionStorage.locale === 'CH' ? type.nameCh : type.nameEn;
    }
  }
});

/***/ }),

/***/ 544:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'news_sub',
  props: ['newsitem'],
  data: function data() {
    return {
      newsId: this.$route.params.newsid,
      news: '',
      locale: sessionStorage.getItem('locale'),
      attachPicture: { CH: '附加圖檔', EN: 'Attach Picture' },
      attachFile: { CH: '附加檔案', EN: 'Attach File' },
      backname: { CH: '回上一頁', EN: 'back' },
      imgUrl: '',
      pictureModal: false
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.showPage();
      this.initNews();
    },
    initNews: function initNews() {
      if (this.newsitem) {
        this.news = this.newsitem;
      }
      if (!this.newsitem) {
        this.getNewsData();
      }
    },
    getNewsData: function getNewsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].notice + ('?id=' + this.newsId)).then(function (response) {
        _this.news = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    back: function back() {
      // this.$router.go(-1);
      window.history.go(-1);
    },
    showPage: function showPage() {
      this.attachPicture = this.attachPicture[this.locale];
      this.attachFile = this.attachFile[this.locale];
      this.backname = this.backname[this.locale];
    },
    showPicture: function showPicture(url) {
      this.pictureModal = true;
      this.imgUrl = url;
    }
  }
});

/***/ }),

/***/ 545:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'page',
  data: function data() {
    return {
      PageLink: this.$route.params.pageName,
      Page: {},
      language: sessionStorage.getItem('locale')

    };
  },
  created: function created() {
    this.init();
  },

  watch: {
    '$route': function $route(to, from) {
      this.PageLink = this.$route.params.pageName;
      this.init();
    }
  },
  computed: {
    allContent: function allContent() {
      if (typeof this.Page.context !== "undefined") {
        return JSON.parse(this.Page.context).map(function (item) {
          return item.content;
        }).join('<br><br>');
      }
    }
  },
  methods: {
    init: function init() {
      this.initPage();
    },
    initPage: function initPage() {
      this.getPageData();
    },
    getPageData: function getPageData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].webpage + ('?linkUrl=' + this.PageLink + '&language=' + this.language)).then(function (response) {
        response.data = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        if (response.data[0]) {
          _this.Page = response.data[0];
        } else {

          _this.$router.push({ name: '404' });
          return false;
        }
      }).then(function () {
        document.title = sessionStorage.locale === 'CH' ? _this.Page.menuTitleCh : _this.Page.menuTitleEn;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    }
  }
});

/***/ }),

/***/ 546:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photo',
  data: function data() {
    return {
      allAlbums: [],
      albums: [],
      searchName: '',
      currentPage: 1,
      pagesize: 12,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initAlbums();
    },
    initAlbums: function initAlbums() {
      this.getAlbumsData();
    },
    getAlbumsData: function getAlbumsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].album).then(function (response) {
        _this.allAlbums = response.data;
        _this.albums = _this.allAlbums;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    search: function search() {
      var _this2 = this;

      if (this.searchName) {
        this.albums = this.allAlbums.filter(function (row) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
            if (key !== 'nameCh' && key !== 'nameEn') return false;
            return String(row[key]).toLowerCase().indexOf(_this2.searchName) !== -1;
          });
        });
      } else this.albums = this.allAlbums;

      this.currentPage = 1;
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    showName: function showName(album) {
      var show = { 'CH': album.nameCh, 'EN': album.nameEn };
      return show[sessionStorage.locale];
    },
    showMemo: function showMemo(album) {
      var show = { 'CH': album.memoCh, 'EN': album.memoEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 547:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_lightbox_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__static_js_lightbox_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__static_js_lightbox_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import "@/../static/js/jquery-1.12.4.js";

// import "@/../static/js/photoin.js";　　　//好像用不到的js





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'photo_in',
  data: function data() {
    return {
      photos: [],
      currentPage: 1,
      pagesize: 12
    };
  },

  props: ['outerphoto'],
  created: function created() {
    this.init();
  },

  computed: {
    photobread: function photobread() {
      for (var i in this.outerphoto) {
        if (this.outerphoto[i].id == this.$route.params.albumId) {
          return this.outerphoto[i].nameCh;
          // 英文待處理
        }
      }
    }
  },
  methods: {
    init: function init() {
      this.initPhotos();
    },
    initPhotos: function initPhotos() {
      this.getPhotosData();
    },
    getPhotosData: function getPhotosData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].picture + ('?albumId=' + this.$route.params.albumId)).then(function (response) {
        _this.photos = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    }
  }
});

/***/ }),

/***/ 548:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__ = __webpack_require__(4);



var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'signup',
  data: function data() {
    return {
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')),
      className: this.$route.params.classname,
      admissionsId: this.$route.params.admissionsid,
      classNow: {},
      admission: {},
      recordToEdit: {
        name: '',
        sex: 2,
        idNo: '',
        birthday: '',
        parentsName: '',
        serviceUnit: '',
        tel: '',
        mobile: '',
        email: '',
        address: '',
        memberType: 1,
        chargesType: 1,
        classWeek: [],
        classCount: 0,
        classTime: [],
        classTimeOther: '',
        coach: 0,
        coachOther: ''
      },
      agree: false
    };
  },
  created: function created() {
    this.init();
  },

  methods: (_methods = {
    init: function init() {
      this.initClass();
      this.initAdmission();
    },
    initClass: function initClass() {
      this.getClassData();
    },
    initAdmission: function initAdmission() {
      this.getAdmissionData();
    },
    getClassData: function getClassData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["b" /* API */].class + ('?id=' + this.classId)).then(function (response) {
        _this.classNow = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getAdmissionData: function getAdmissionData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["b" /* API */].classadmissions + ('?id=' + this.admissionsId)).then(function (response) {
        _this2.admission = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    saveData: function saveData() {
      var _this3 = this;

      try {
        this.checkField();
      } catch (error) {
        alert(error.message);
        return;
      }

      var form = new FormData();

      form.append('admissionsId', this.admissionsId);
      form.append('name', this.recordToEdit.name || '');
      form.append('sex', this.recordToEdit.sex || '');
      form.append('idNo', this.recordToEdit.idNo || '');
      form.append('birthday', this.recordToEdit.birthday || '');
      form.append('parentsName', this.recordToEdit.parentsName || '');
      form.append('serviceUnit', this.recordToEdit.serviceUnit || '');
      form.append('tel', this.recordToEdit.tel || '');
      form.append('mobile', this.recordToEdit.mobile || '');
      form.append('email', this.recordToEdit.email || '');
      form.append('address', this.recordToEdit.address || '');
      form.append('memberType', this.recordToEdit.memberType.toString());
      form.append('chargesType', this.recordToEdit.chargesType || 0);
      form.append('classWeek', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.recordToEdit.classWeek) || '');
      form.append('classCount', this.recordToEdit.classCount.toString());
      form.append('classTime', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.recordToEdit.classTime) || '');
      form.append('classTimeOther', this.recordToEdit.classTimeOther || '');
      form.append('coach', this.recordToEdit.coach.toString());
      form.append('coachOther', this.recordToEdit.coachOther || '');

      this.$Message.loading({ content: '儲存中...', duration: 0 });

      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["b" /* API */].application, form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
        _this3.$Message.destroy();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__["b" /* ShowMessage */])(__WEBPACK_IMPORTED_MODULE_3__assets_project_setting_config__["c" /* Message */].SaveSuccessfully[sessionStorage.locale]);
        _this3.$router.push({ name: 'class_item' });
      }).catch(function (error) {
        _this3.$Message.destroy();
        __WEBPACK_IMPORTED_MODULE_4__assets_library_axiosErrorHandler__["c" /* PostErrorHandler */].bind(_this3)(error, 'application');
      });
    },
    checkField: function checkField() {
      this.checkAgree();
      this.checkEmpty();
      this.checkClassCount();
      this.checkIdNo();
      this.checkTel();
      this.checkMobile();
      this.checkEmail();
    },
    checkEmpty: function checkEmpty() {
      if (!this.recordToEdit.name) throw new Error('姓名必填');
      if (!this.recordToEdit.classCount) throw new Error('課堂數必填');
      if (!this.recordToEdit.idNo) throw new Error('身分證字號必填');
      if (!this.recordToEdit.parentsName) throw new Error('家長必填');
      if (!this.recordToEdit.serviceUnit) throw new Error('服務單位必填');
      if (!this.recordToEdit.tel) throw new Error('聯絡電話必填');
      if (!this.recordToEdit.mobile) throw new Error('手機必填');
      if (!this.recordToEdit.email) throw new Error('Email必填');
      if (!this.recordToEdit.address) throw new Error('聯絡地址必填');
    },
    checkClassCount: function checkClassCount() {
      if (isNaN(parseInt(this.recordToEdit.classCount))) throw new Error('課堂數需為數字');
    },
    checkIdNo: function checkIdNo() {
      var regExp = /^[A-Z][0-9]{9}$/;
      if (!this.recordToEdit.idNo.match(regExp)) {
        throw new Error('身分證字號無效');
      }
    },
    checkTel: function checkTel() {
      var regExp = /^[0-9\-()]*$/;
      if (this.recordToEdit.tel && !this.recordToEdit.tel.match(regExp)) {
        throw new Error('電話欄位無效');
      }
    },
    checkMobile: function checkMobile() {
      var regExp = /^09[0-9]{8}$/;
      if (this.recordToEdit.mobile && !this.recordToEdit.mobile.match(regExp)) {
        throw new Error('手機欄位無效');
      }
    },
    checkEmail: function checkEmail() {
      var regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.recordToEdit.email) {
        throw new Error('請填寫電子信箱');
      }
      if (this.recordToEdit.email && !this.recordToEdit.email.match(regExp)) {
        throw new Error('電子信箱欄位無效');
      }
    },
    checkAgree: function checkAgree() {
      if (!this.agree) throw new Error('請先詳閱上課須知及各注意事項，並同意遵行');
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'checkClassCount', function checkClassCount() {
    if (this.recordToEdit.classCount && isNaN(parseInt(this.recordToEdit.classCount))) throw new Error('課堂數需為數字');
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'dateChange', function dateChange(date) {
    this.recordToEdit.birthday = date;
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, 'classTypeName', function classTypeName(admission) {
    if (sessionStorage.locale === 'CH') {
      var level = ['', '初階', '進階', '矯正'],
          maxPersonal = ['零', '一', '二', '三', '四', '五'];
      if (admission.type === 1) {
        return admission.maxPersonal + level[admission.classLevel] + '班';
      } else if (admission.type === 2) {
        return '團體' + level[admission.classLevel] + '班';
      }
    } else {
      var _level = ['', 'Beginner', 'Advanced', 'Correction'],
          _maxPersonal = ['zero', 'one', 'two', 'three', 'four', 'five'];
      if (admission.type === 1) {
        return admission.maxPersonal + ' ' + _level[admission.classLevel] + ' class';
      } else if (admission.type === 2) {
        return 'Group ' + _level[admission.classLevel] + ' Class';
      }
    }
  }), _methods)
});

/***/ }),

/***/ 549:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site',
  data: function data() {
    return {
      sites: []
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initSites();
    },
    initSites: function initSites() {
      this.getSitesData();
    },
    getSitesData: function getSitesData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].site).then(function (response) {
        _this.sites = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    handleReceivedSites: function handleReceivedSites() {
      this.sites = this.sites.filter(function (site) {
        return trash === 0;
      });
    },
    pushToSite: function pushToSite(index) {
      this.$router.push({ name: 'site_info', params: { site: index } });
    },
    showName: function showName(site) {
      var show = { 'CH': site.nameCh, 'EN': site.nameEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 550:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'site',
  props: ['sites'],
  data: function data() {
    return {
      siteindex: this.$route.params.site,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    // this.init();
  },

  watch: {
    $route: function $route() {
      this.siteindex = this.$route.params.site;
    }
  },
  methods: {
    init: function init() {
      this.initSites();
    },
    initSites: function initSites() {
      this.getSitesData();
    },
    getSitesData: function getSitesData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].site).then(function (response) {
        _this.sites = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    back: function back() {
      // this.$router.go(-1);
      window.history.go(-1);
    },
    showName: function showName(site) {
      var show = { 'CH': site.nameCh, 'EN': site.nameEn };
      return show[sessionStorage.locale];
    },
    showIntroduction: function showIntroduction(site) {
      var introduction = {
        CH: site.introductionCh,
        EN: site.introductionEn
      };
      return introduction[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 551:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher',
  data: function data() {
    return {
      allTeachers: [],
      teachers: [],
      teacher: '',
      searchName: '',
      currentPage: 1,
      pagesize: 10,
      on: { 1: { on: true } },
      titleIndex: 1,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')),
      customs: []
    };
  },
  created: function created() {
    this.init();
  },


  methods: {
    init: function init() {
      this.initTeachers();
      this.initCustoms();
    },
    initTeachers: function initTeachers() {
      this.getTeachersData();
    },
    getTeachersData: function getTeachersData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].teacher).then(function (response) {
        _this.allTeachers = response.data.filter(function (data) {
          return data.trash !== 1;
        });
        _this.selectTitle(_this.titleIndex);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    initCustoms: function initCustoms() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].teacherCustom).then(function (response) {
        _this2.customs = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    pushToInfo: function pushToInfo(teacher, index) {
      this.teacher = teacher;
      var routename = ['teacher_basic', 'teacher_edu', 'teacher_prize', 'teacher_seminar', 'teacher_journal', 'teacher_book', 'teacher_research'];
      this.$router.push({ name: routename[index], params: { teacherid: teacher.id } });
    },
    returnDept: function returnDept(dept) {
      return dept === 1 ? '體育室主任' : '體育室副主任';
    },
    teachercustoms: function teachercustoms(teacher) {
      return this.customs.filter(function (item) {
        return item.teacherId == teacher.id;
      });
    },
    search: function search() {
      var _this3 = this;

      if (this.searchName) {
        this.teachers = this.teachers.filter(function (row) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
            if (key !== 'nameCh' && key !== 'nameEn') return false;
            return String(row[key]).toLowerCase().indexOf(_this3.searchName) !== -1;
          });
        });
      } else this.selectTitle(this.titleIndex);

      this.currentPage = 1;
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    focus: function focus(index) {
      this.on = {};
      this.on[index] = { on: true };
    },
    selectTitle: function selectTitle(index) {
      this.titleIndex = index;
      this.currentPage = 1;
      this.teachers = this.allTeachers.filter(function (teacher) {
        return teacher.title == index;
      });
    },
    pushToTeacher: function pushToTeacher() {
      if (this.$route.name !== 'teacher') this.$router.push({ name: 'teacher' });
    },
    showTitle: function showTitle() {
      var title = ['', this.showPage.professor, this.showPage.associateProfessor, this.showPage.assistantProfessor, this.showPage.distinguishedProfessor, this.showPage.fullTimeLecturer, this.showPage.adjunctProfessor, this.showPage.adjunctAssociateProfessor, this.showPage.adjunctAssistantProfessor, this.showPage.adjunctLecture, this.showPage.teachingAssistant, this.showPage.honoraryProfessor];
      return title[this.titleIndex];
    },
    showName: function showName(custom) {
      var name = { 'CH': custom.nameCh, 'EN': custom.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 552:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_basic',
  props: ['teacher'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    showDegree: function showDegree(background) {
      var degreeEn = { '學士': 'Bachelor', '碩士': 'Master', '博士': 'Doctor' },
          degree = { CH: background.degree, EN: degreeEn[background.degree] };
      return degree[sessionStorage.locale];
    },
    showSchool: function showSchool(background) {
      var school = { CH: background.school_ch, EN: background.school_en };
      return school[sessionStorage.locale];
    },
    showTitle: function showTitle(title) {
      var titlename = ['', this.showPage.professor, this.showPage.associateProfessor, this.showPage.assistantProfessor, this.showPage.distinguishedProfessor, this.showPage.fullTimeLecturer, this.showPage.adjunctProfessor, this.showPage.adjunctAssociateProfessor, this.showPage.adjunctAssistantProfessor, this.showPage.adjunctLecture, this.showPage.teachingAssistant];
      return titlename[title];
    },
    showResearchArea: function showResearchArea(researchArea) {
      var research = { CH: researchArea.research_area_ch, EN: researchArea.research_area_en };
      return research[sessionStorage.locale];
    },
    showResearchSummary: function showResearchSummary() {
      var research = { CH: this.teacher.researchSummaryCh, EN: this.teacher.researchSummaryEn };
      return research[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 553:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_book',
  props: ['teacher', 'teacherpublications'],
  data: function data() {
    return {
      teacherId: this.$route.params.teacherid,
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    publication: function publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        var dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    showReviewSystem: function showReviewSystem(teacherpublication) {
      var showCH = { 0: '無', 1: '有' },
          showEN = { 0: 'nonexist', 1: 'exist' },
          show = { CH: showCH[teacherpublication.reviewSystem], EN: showEN[teacherpublication.reviewSystem] };
      return show[sessionStorage.locale];
    },
    showName: function showName(teacherpublication) {
      var name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 554:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_custom',
  props: ['customs'],
  data: function data() {
    return {
      custom: this.$route.params.custom,
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },

  watch: {
    $route: function $route() {
      this.custom = this.$route.params.custom;
    }
  },
  created: function created() {},

  methods: {
    showName: function showName(custom) {
      var show = { 'CH': custom.nameCh, 'EN': custom.nameEn };
      return show[sessionStorage.locale];
    },
    showContext: function showContext(custom) {
      var show = { 'CH': custom.contextCh, 'EN': custom.contextEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 555:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_edu',
  props: ['teacher'],
  data: function data() {
    var _this = this;

    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')),
      backgroundColumn: [{
        title: this.showDegreeName(),
        key: 'degree',
        render: function render(h, params) {
          return h('div', [h('span', _this.showDegree(params.row))]);
        }
      }, {
        title: this.showSchool(),
        key: 'school_ch'
      }, {
        title: this.showSchoolEn(),
        key: 'school_en'
      }, {
        title: this.showGraduationYear(),
        key: 'graduation_year'
      }]
    };
  },
  created: function created() {},

  methods: {
    showDegree: function showDegree(background) {
      var degreeEn = { '學士': 'Bachelor', '碩士': 'Master', '博士': 'Doctor' },
          degree = { CH: background.degree, EN: degreeEn[background.degree] };
      return degree[sessionStorage.locale];
    },
    showDegreeName: function showDegreeName() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')).degree;
    },
    showSchool: function showSchool() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')).school;
    },
    showSchoolEn: function showSchoolEn() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')).school_en;
    },
    showGraduationYear: function showGraduationYear() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale')).graduation_year;
    },
    showCourse: function showCourse(course) {
      var show = { CH: course.course_ch, EN: course.course_en };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 556:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_info',
  props: ['teacher'],
  data: function data() {
    return {
      teacherId: this.$route.params.teacherid,
      info: {},
      teacherpublications: [],
      customs: [],
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initInfo();
      this.initPublications();
      this.initCustoms();
    },
    initInfo: function initInfo() {
      if (this.teacher) this.info = this.teacher;else this.getData();
    },
    initPublications: function initPublications() {
      this.getPublicationsData();
    },
    initCustoms: function initCustoms() {
      this.getCustomsData();
    },
    getData: function getData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].teacher + ('?id=' + this.teacherId)).then(function (response) {
        _this.info = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getPublicationsData: function getPublicationsData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].teacherpublication + ('?teacherId=' + this.teacherId)).then(function (response) {
        _this2.teacherpublications = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    getCustomsData: function getCustomsData() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].teacherCustom + ('?teacherid=' + this.teacherId)).then(function (response) {
        _this3.customs = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this3)(error);
      });
    },
    showName: function showName(custom) {
      var name = { 'CH': custom.nameCh, 'EN': custom.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_journal',
  props: ['teacher', 'teacherpublications'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    publication: function publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        var dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    showName: function showName(teacherpublication) {
      var name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn };
      return name[sessionStorage.locale];
    },
    showIssueNumber: function showIssueNumber(teacherpublication) {
      var show = {
        CH: '\u7B2C ' + teacherpublication.journal + ' \u671F\uFF0C\u7B2C ' + teacherpublication.journalUnit + ' \u55AE\u5143',
        EN: 'Vol. ' + teacherpublication.journal + ' No. ' + teacherpublication.journalUnit
      };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 558:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_prize',
  props: ['teacher'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    showHonor: function showHonor() {
      var show = { CH: this.teacher.honorCh, EN: this.teacher.honorEn };
      return show[sessionStorage.locale];
    },
    showHistory: function showHistory() {
      var show = { CH: this.teacher.historyCh, EN: this.teacher.historyEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 559:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_research',
  props: ['teacher', 'teacherpublications'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    executiveDateS: function executiveDateS(teacherpublication) {
      if (teacherpublication.executiveDateS) {
        var dateArr = teacherpublication.executiveDateS.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    executiveDateE: function executiveDateE(teacherpublication) {
      if (teacherpublication.executiveDateE) {
        var dateArr = teacherpublication.executiveDateE.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    showFundSource: function showFundSource(teacherpublication) {
      var show = { CH: teacherpublication.fundSourceCh, EN: teacherpublication.fundSourceEn };
      return show[sessionStorage.locale];
    },
    showName: function showName(teacherpublication) {
      var show = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'teacher_seminar',
  props: ['teacher', 'teacherpublications'],
  data: function data() {
    return {
      info: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {},

  methods: {
    publication: function publication(teacherpublication) {
      if (teacherpublication.publicationAt) {
        var dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        return dateArr[0];
      }
      return '';
    },
    publicationmonth: function publicationmonth(teacherpublication) {
      if (teacherpublication.publicationAt) {
        var dateArr = teacherpublication.publicationAt.split(' ')[0].split('-');
        switch (dateArr[1]) {
          case '01':
            return 'January';
            break;
          case '02':
            return 'February';
            break;
          case '03':
            return 'March';
            break;
          case '04':
            return 'April';
            break;
          case '05':
            return 'May';
            break;
          case '06':
            return 'June';
            break;
          case '07':
            return 'July';
            break;
          case '08':
            return 'August';
            break;
          case '09':
            return 'September';
            break;
          case '10':
            return 'October';
            break;
          case '11':
            return 'November';
            break;
          case '12':
            return 'December';
            break;
          default:
            break;
        }
      }
      return '';
    },
    showName: function showName(teacherpublication) {
      var name = { 'CH': teacherpublication.nameCh, 'EN': teacherpublication.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team',
  data: function data() {
    return {
      teams: [],
      teamInfo: {},
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initTeams();
      this.initTeamInfo();
    },
    initTeams: function initTeams() {
      this.getTeamsData();
    },
    initTeamInfo: function initTeamInfo() {
      this.getTeamInfo();
    },
    getTeamsData: function getTeamsData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].team).then(function (response) {
        _this.teams = response.data.filter(function (data) {
          return data.trash !== 1;
        });
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    getTeamInfo: function getTeamInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].setting + '?id=1').then(function (response) {
        _this2.teamInfo = response.data;
        _this2.handleReceivedTeamInfo();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    handleReceivedTeamInfo: function handleReceivedTeamInfo() {
      this.teamInfo.teamIntroductionCh = this.teamInfo.teamIntroductionCh;
      this.teamInfo.teamIntroductionEn = this.teamInfo.teamIntroductionEn;
    },
    showIntroduction: function showIntroduction() {
      var introduction = { CH: this.teamInfo.teamIntroductionCh,
        EN: this.teamInfo.teamIntroductionEn };
      return introduction[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 562:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team_type',
  props: ['teams'],
  data: function data() {
    return {
      teamId: this.$route.params.teamid,
      team: '',
      albums: [],
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  watch: {
    teams: function teams() {
      this.init();
    }
  },
  methods: {
    init: function init() {
      this.initTeam();
      this.initAlbums();
    },
    initTeam: function initTeam() {
      var _this = this;

      this.teams.some(function (team) {
        if (team.id == _this.teamId) {
          _this.team = team;
          return true;
        }
      });
    },
    initAlbums: function initAlbums() {
      this.getAlbumsData();
    },
    getAlbumsData: function getAlbumsData() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__["b" /* API */].album + ('?teamId=' + this.teamId)).then(function (response) {
        _this2.albums = response.data;
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this2)(error);
      });
    },
    showName: function showName(album) {
      var show = { 'CH': album.nameCh, 'EN': album.nameEn };
      return show[sessionStorage.locale];
    },
    showIntroduction: function showIntroduction() {
      var introduction = { CH: this.team.introductionCh,
        EN: this.team.introductionEn };
      return introduction[sessionStorage.locale];
    },
    showMemo: function showMemo(album) {
      var show = { 'CH': album.memoCh, 'EN': album.memoEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_library_axiosErrorHandler__ = __webpack_require__(4);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'team_type',
  props: ['teams'],
  data: function data() {
    return {
      teamtypeId: this.$route.params.teamtypeid
    };
  },
  created: function created() {},

  methods: {
    selectTeam: function selectTeam(team) {
      this.$router.push({ name: 'team_info', params: { teamid: team.id } });
    },
    showName: function showName(teamitem) {
      var name = { 'CH': teamitem.nameCh, 'EN': teamitem.nameEn };
      return name[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 564:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__ = __webpack_require__(4);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video',
  data: function data() {
    return {
      allVideos: [],
      videos: [],
      nowVideo: '',
      nowTitle: '',
      searchName: '',
      currentPage: 1,
      pagesize: 10,
      modalvideo: false,
      sortstatus: false,
      showPage: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["k" /* ShowPage */])(sessionStorage.getItem('locale'))
    };
  },
  created: function created() {
    this.init();
  },

  methods: {
    init: function init() {
      this.initVideos();
    },
    initVideos: function initVideos() {
      this.getVideosData();
    },
    getVideosData: function getVideosData() {
      var _this = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].video).then(function (response) {
        _this.allVideos = response.data;
        _this.sort();
        _this.videos = _this.allVideos.slice();
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_3__assets_library_axiosErrorHandler__["a" /* GetErrorHandler */].bind(_this)(error);
      });
    },
    selectVideo: function selectVideo(video) {
      this.nowVideo = video.fileUrl;
      this.nowTitle = this.showTitle(video);
      this.modalvideo = true;
      this.addViewCount(video);
    },
    addViewCount: function addViewCount(video) {

      var form = new FormData();

      form.append('id', video.id);

      // params   id account name isActive limit all
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__assets_project_setting_config__["b" /* API */].video + '/viewer', form, { headers: { 'Content-Type': 'multipart/form-data' } }).then(function (response) {
        // ShowMessage(Message.SaveSuccessfully[sessionStorage.locale]);
      }).catch(function (error) {
        // PostErrorHandler.bind(this)(error, 'album');
      });
    },
    search: function search() {
      var _this2 = this;

      if (this.searchName) {
        this.videos = this.allVideos.filter(function (row) {
          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).some(function (key) {
            if (key !== 'titleCh' && key !== 'titleEn') return false;
            return String(row[key]).toLowerCase().indexOf(_this2.searchName) !== -1;
          });
        });
      } else this.videos = this.allVideos.slice();

      this.currentPage = 1;
    },
    sort: function sort() {
      this.sortstatus = true;
      this.allVideos.sort(function (a, b) {
        var aDate = new Date(a.createdAt),
            bDate = new Date(b.createdAt);
        if (aDate.getTime() < bDate.getTime()) return 1;
        return -1;
      });
    },
    sortCancel: function sortCancel() {
      this.sortstatus = false;
      this.videos = this.allVideos.slice();
    },
    changePage: function changePage(page) {
      this.currentPage = page;
    },
    inCurrentPage: function inCurrentPage(index) {
      var currentPage = this.currentPage,
          pagesize = this.pagesize;
      return (currentPage - 1) * pagesize <= index && index < currentPage * pagesize;
    },
    showTitle: function showTitle(video) {
      var show = { CH: video.titleCh, EN: video.titleEn };
      return show[sessionStorage.locale];
    }
  }
});

/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/**
 * 首頁公告分類頁籤切換
 *
 * 原本這段程式碼被附加在 static/js/jquery-latest.min.js 的檔尾（該檔實為
 * jQuery 1.11.1，含 CVE-2020-11022）。為了移除該版 jQuery，將這段自訂邏輯
 * 抽出獨立成模組，內容未做任何行為變更。
 *
 * 其中的 $ 由 webpack ProvidePlugin 注入（見 build/webpack.base.conf.js），
 * 使用的是 package.json 指定的 npm jQuery。
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  init: function init() {
    var _showTab = 0;
    var $defaultLi = $('ul.tabs li').eq(_showTab);
    $($defaultLi.find('a').attr('href')).siblings().hide();
    $('ul.tabs li').click(function () {
      var $this = $(this),
          _clickTab = $this.find('a').attr('href');
      $('ul.tabs li').removeClass('active');
      $this.addClass('active').siblings('.active');
      $(_clickTab).stop(false, true).fadeIn().siblings().hide();

      return false;
    }).find('a').focus(function () {
      this.blur();
    });
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(6)))

/***/ }),

/***/ 660:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_locale_zh_TW__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_iview_dist_locale_zh_TW___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_iview_dist_locale_zh_TW__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview_dist_styles_iview_css__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_css__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flexslider__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_flexslider___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_flexslider__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_bootstrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_bootstrap__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_iview___default.a, { locale: __WEBPACK_IMPORTED_MODULE_5_iview_dist_locale_zh_TW___default.a });

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.ignoredElements = ['gcse:search']; // google 站內搜尋

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* router */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 70:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: dropdown.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.4.1'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector !== '#' ? $(document).find(selector) : null

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 71:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: modal.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#modals
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options = options
    this.$body = $(document.body)
    this.$element = $(element)
    this.$dialog = this.$element.find('.modal-dialog')
    this.$backdrop = null
    this.isShown = null
    this.originalBodyPad = null
    this.scrollbarWidth = 0
    this.ignoreBackdropClick = false
    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION = '3.4.1'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
          this.$element[0] !== e.target &&
          !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    var scrollbarWidth = this.scrollbarWidth
    if (this.bodyIsOverflowing) {
      this.$body.css('padding-right', bodyPad + scrollbarWidth)
      $(this.fixedContent).each(function (index, element) {
        var actualPadding = element.style.paddingRight
        var calculatedPadding = $(element).css('padding-right')
        $(element)
          .data('padding-right', actualPadding)
          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
      })
    }
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
    $(this.fixedContent).each(function (index, element) {
      var padding = $(element).data('padding-right')
      $(element).removeData('padding-right')
      element.style.paddingRight = padding ? padding : ''
    })
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this = $(this)
      var data = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this = $(this)
    var href = $this.attr('href')
    var target = $this.attr('data-target') ||
      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7

    var $target = $(document).find(target)
    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 72:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/* ========================================================================
 * Bootstrap: tooltip.js v3.4.1
 * https://getbootstrap.com/docs/3.4/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

+function ($) {
  'use strict';

  var DISALLOWED_ATTRIBUTES = ['sanitize', 'whiteList', 'sanitizeFn']

  var uriAttrs = [
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
  ]

  var ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i

  var DefaultWhitelist = {
    // Global attributes allowed on any supplied element below.
    '*': ['class', 'dir', 'id', 'lang', 'role', ARIA_ATTRIBUTE_PATTERN],
    a: ['target', 'href', 'title', 'rel'],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: ['src', 'alt', 'title', 'width', 'height'],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
  }

  /**
   * A pattern that recognizes a commonly useful subset of URLs that are safe.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var SAFE_URL_PATTERN = /^(?:(?:https?|mailto|ftp|tel|file):|[^&:/?#]*(?:[/?#]|$))/gi

  /**
   * A pattern that matches safe data URLs. Only matches image, video and audio types.
   *
   * Shoutout to Angular 7 https://github.com/angular/angular/blob/7.2.4/packages/core/src/sanitization/url_sanitizer.ts
   */
  var DATA_URL_PATTERN = /^data:(?:image\/(?:bmp|gif|jpeg|jpg|png|tiff|webp)|video\/(?:mpeg|mp4|ogg|webm)|audio\/(?:mp3|oga|ogg|opus));base64,[a-z0-9+/]+=*$/i

  function allowedAttribute(attr, allowedAttributeList) {
    var attrName = attr.nodeName.toLowerCase()

    if ($.inArray(attrName, allowedAttributeList) !== -1) {
      if ($.inArray(attrName, uriAttrs) !== -1) {
        return Boolean(attr.nodeValue.match(SAFE_URL_PATTERN) || attr.nodeValue.match(DATA_URL_PATTERN))
      }

      return true
    }

    var regExp = $(allowedAttributeList).filter(function (index, value) {
      return value instanceof RegExp
    })

    // Check if a regular expression validates the attribute.
    for (var i = 0, l = regExp.length; i < l; i++) {
      if (attrName.match(regExp[i])) {
        return true
      }
    }

    return false
  }

  function sanitizeHtml(unsafeHtml, whiteList, sanitizeFn) {
    if (unsafeHtml.length === 0) {
      return unsafeHtml
    }

    if (sanitizeFn && typeof sanitizeFn === 'function') {
      return sanitizeFn(unsafeHtml)
    }

    // IE 8 and below don't support createHTMLDocument
    if (!document.implementation || !document.implementation.createHTMLDocument) {
      return unsafeHtml
    }

    var createdDocument = document.implementation.createHTMLDocument('sanitization')
    createdDocument.body.innerHTML = unsafeHtml

    var whitelistKeys = $.map(whiteList, function (el, i) { return i })
    var elements = $(createdDocument.body).find('*')

    for (var i = 0, len = elements.length; i < len; i++) {
      var el = elements[i]
      var elName = el.nodeName.toLowerCase()

      if ($.inArray(elName, whitelistKeys) === -1) {
        el.parentNode.removeChild(el)

        continue
      }

      var attributeList = $.map(el.attributes, function (el) { return el })
      var whitelistedAttributes = [].concat(whiteList['*'] || [], whiteList[elName] || [])

      for (var j = 0, len2 = attributeList.length; j < len2; j++) {
        if (!allowedAttribute(attributeList[j], whitelistedAttributes)) {
          el.removeAttribute(attributeList[j].nodeName)
        }
      }
    }

    return createdDocument.body.innerHTML
  }

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.4.1'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    },
    sanitize : true,
    sanitizeFn : null,
    whiteList : DefaultWhitelist
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $(document).find($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    var dataAttributes = this.$element.data()

    for (var dataAttr in dataAttributes) {
      if (dataAttributes.hasOwnProperty(dataAttr) && $.inArray(dataAttr, DISALLOWED_ATTRIBUTES) !== -1) {
        delete dataAttributes[dataAttr]
      }
    }

    options = $.extend({}, this.getDefaults(), dataAttributes, options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    if (options.sanitize) {
      options.template = sanitizeHtml(options.template, options.whiteList, options.sanitizeFn)
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo($(document).find(this.options.container)) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    if (this.options.html) {
      if (this.options.sanitize) {
        title = sanitizeHtml(title, this.options.whiteList, this.options.sanitizeFn)
      }

      $tip.find('.tooltip-inner').html(title)
    } else {
      $tip.find('.tooltip-inner').text(title)
    }

    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }

  Tooltip.prototype.sanitizeHtml = function (unsafeHtml) {
    return sanitizeHtml(unsafeHtml, this.options.whiteList, this.options.sanitizeFn)
  }

  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(6)))

/***/ }),

/***/ 885:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 891:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 895:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 896:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 897:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 903:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 905:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 906:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 914:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 918:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 921:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 926:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 928:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 931:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 933:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 935:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 938:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 939:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 944:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 946:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 949:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 952:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 953:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 954:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 960:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 971:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 973:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 975:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 979:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 985:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 987:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 988:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 995:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[660]);


// WEBPACK FOOTER //
// static/js/app.241e3c237b6d1b1e5b2c.js